//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebControls.GEvidenceElPodaniDlg.ts              </Name>
//    <Description> Elektronické podání.                                        </Description>
//    <Author>      Šebesta David                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2018                            </Copyright>
//    <Created>     2018-08-01                                                  </Created>
//  </FileHeader>

namespace Gordic.Pod.WebControls {
    const { gcontent } = Decorators

    interface Nabidka { nazev?: string, icon?: string | string[] }
    
    /**
     * GOdeslaniTiskAdresDlg.
     *
     * @returns
     */
    @gcontent
    export class GEvidenceElPodaniDlg extends GContentBase {
        //#region Property


        private readonly Title: string

        private readonly IxbArray?: string[]; // pole IXb       

        private readonly Ixb?: string;  // prvni ixb  z pole ixb        

        private PouzePrehled: boolean

        private IsFaze_SSD: boolean
        private MoznostEditovatNazevPrilohyElPodani: boolean

        //aktualni číslo kroku na kterem stojime
        private aktualniCisloKroku?: number = 0;    //aktualni krok pruvodce    

        private provedenoKroku?: number = 0; // kolik bylo provedeno kroku na automat.
        
        // formy hlaivkčyk
        private $FormHlavicka?: JQuery<HTMLElement> = undefined;    // zakladní hlavička
        private $FormHlavickaObsah?: JQuery<HTMLElement> = undefined;    // obsah
        private $FormHlavickaObsahFade?: JQuery<HTMLElement> = undefined;    // obsah
        private $FormHlavickaObsahText?: JQuery<HTMLElement> = undefined;    // obsah
        private $FormHlavickaDruha?: JQuery<HTMLElement> = undefined;   // rozšireni hlavicky pro DS

        //grid
        private $Grid?: JQuery<HTMLElement> = undefined;

        //grid
        private $GridVlastnosti?: JQuery<HTMLElement> = undefined;

        private initDto?: Gordic.Pod.WebControls.GEvidenceElPodaniInitDto;

        //naposledny načtene hodnotyze serveru
        private VysledekSpustitPodaniDto?: Gordic.Pod.WebControls.GEvidenceElPodaniSpustPodaniDto = undefined;
        private VysledekNactiDataDto?: Gordic.Pod.WebControls.GEvidenceElPodaniNactiDataDto = undefined;
        private VysledekKrok1Call1?: Gordic.Pod.WebControls.GKrok1ElEvidenceDto = undefined;
        private VysledekKrok2Call?: Gordic.Pod.WebControls.GKrok2ElEvidenceDto = undefined;
        private VysledekKrok3Call?: Gordic.Pod.WebControls.GKrok3ElEvidenceDto = undefined;
        private VysledekKrok4Call?: Gordic.Pod.WebControls.GKrok4ElEvidenceDto = undefined;
        private Krok4VysledekRucnihoOvereni;
        private VysledekKrok5Call?: Gordic.Pod.WebControls.GKrok5ElEvidenceDto = undefined;
        private Krok5VysledekFormu: any;
        private VysledekKrok6Call?: Gordic.Pod.WebControls.GKrok6ElEvidenceDto = undefined;
        private Krok6VysledekFormu: any;

        private Krok6VysledekOdeslatPozvrzeni: GEvidenceElPodaniOdeslatPotvrzeniDto = undefined;


        private VysledekVygenerovanaOdpoved?: Gordic.Pod.WebControls.GEvidenceElPodaniGenerovatOdpovedDto = undefined;

        //hodnota chceckboxu
        private OrigEml: boolean = false
        private OrigEmlAddTST: boolean = false
        


        //zda je potřeba znovu načístat data při vykreslování těchto stepu
        private Step2_MaAktualniDataProVykresleni: boolean = false
        private Step3_MaAktualniDataProVykresleni: boolean = false
        private Step4_MaAktualniDataProVykresleni: boolean = false
        private Step5_MaAktualniDataProVykresleni: boolean = false

        private Step6_MaAktualniDataProVykresleni: boolean = false


        private PolePovolenychKroku: boolean[] 

        private UpozorneniNaNeexistujiciESU: boolean = false;
        //#endregion


        private IsFormClosed: boolean = false; // zda již byl formulář zavřen
        private OdemknoutPodaniAfterClose: boolean; // zda odemknout podani
        private IfCloseForm: boolean; // zda má dojít k zavření protože při nějaké operaci to tak vyhodnotilo


        //pomocne krok 6
        private ssl_typd_neurpo: number; // parametr
        private typPisNeurceno: string; // parametr
        private typPis: string; // parametr
        private Ixp: string; 
        

        //proste ruzne promenene
        private OriginalJeZpravaSymbol: string;
        private ViewGridu: Data.View;
        private Obsah: string;
        private EmailPuvodni: string;
        private EmailProp: string;
        private OdesIDDS: string;
        private OdpEmail: string;
        private DuvodOdmitnuti: Interface.DuvodOdmitnutiElPodani;

        private VybraneSoubory: Pod.Interface.GElPodaniPrilohyStrukturovaneDto[]

        private ZastTxt: string;
        private PIDDokumentu: string;
        private IsPotvrzSigned: string;

        private NejsouViryValue: boolean = false;
        private ZobrDetCbxValue: boolean = false;
        private ZobrDetCbxDisable: boolean = false;
        private MultiSelectAddCasRaz: boolean = false;
        private ZavreniBezOtazky: boolean = false
        

        private X0000: string;
        private X0001: string;
        private X0002: string;

        private PodElPodaniSettings: Gordic.Pod.Interface.GPodElPodaniSettingsDto

        //JS 26.02. 2023 uprava 
        // private PoleGridu: Pod.Interface.GElPodaniPrilohyStrukturovaneDto[] 
        private PoleGridu: Pod.Interface.GElPodaniPrilohyStrukturovaneDto[] 

        private ZpracovatJakoMsgInMsg: boolean = false

        private ixsDpo: string;

        // 03.01.2018 - TFeik
        // Oprava po prepsani Wizarda do TS, kde z něj je classa.
        /**
         * Classa Wizardu.
         * @type {Gordic.Wizard}
         */
        private Wizard?: Gordic.Wizard

        logOptions = { name: "Gordic.Pod.WebControls.GEvidenceElPodaniDlg", fileName: "GEvidenceElPodaniDlg.ts", authorCode: 484 };  
        /**
         * OnContentReady.
         *
         * @author  dsebesta
         * @date    01.09.2017
         */
        public onContentReady(): void {
            const that: GEvidenceElPodaniDlg = this;
            this.log.trace("onContentReady");

            this.Krok4VysledekRucnihoOvereni = {};
            this.Krok5VysledekFormu = {};
            this.Krok6VysledekFormu = {};
            this.PolePovolenychKroku = [false, false, false, false, false, false];
            this.VybraneSoubory = [];
            this.PoleGridu = [];



            this.beginOperation();
            this._createMenu();
            this.inicializace();
     


            this.endOperation();
            this.initHelpTag();
        }

        private initHelpTag() {
            this.element.addHelpContext('ElPodani');
        }

        //#region Inicializace
        /**
         * inicializace contentu
         * @param {Gordic.Pod.WebControls.GEvidenceElPodaniNactiDataDto} NactiDto?
         */
        private inicializace(NactiDto?: Gordic.Pod.WebControls.GEvidenceElPodaniNactiDataDto): void {
            const that: GEvidenceElPodaniDlg = this;
            this.zavolejNactiData();

        }

        /**
         * zavolani funkce "NactiData" na serveru
         * @param {Gordic.Pod.WebControls.GEvidenceElPodaniNactiDataDto} NactiDto?
         */
        private zavolejNactiData(NactiDto?: Gordic.Pod.WebControls.GEvidenceElPodaniNactiDataDto): void {
            const that: GEvidenceElPodaniDlg = this;
            if (NactiDto == null) {
                let temp: Gordic.Pod.WebControls.GEvidenceElPodaniNactiDataDto = {};
                NactiDto = temp;
            }
            ;
            this.call<Gordic.Pod.WebControls.GEvidenceElPodaniNactiDataDto>("NactiData", { NactiDataDto: NactiDto }, null/*, { progressState: { text: "jres:31950220" }}*/).done(function (retVal) { //RC 31950220 : Načítám data
                if (retVal) {
                    ;
                    that.VysledekNactiDataDto = retVal;
                    that.spracujOdpovedZNactiData(retVal);
                }

            })

        }

        /**
         * zpracovani odpovedi funkce "NactiData" ze serveru
         * @param {Gordic.Pod.WebControls.GEvidenceElPodaniNactiDataDto} NactiDto
         */
        private spracujOdpovedZNactiData(NactiDto: Gordic.Pod.WebControls.GEvidenceElPodaniNactiDataDto): void {
            const that: GEvidenceElPodaniDlg = this;
            this.zkontrolujInitHlasku(NactiDto, NactiDto.InitHlaska1).done(function () {
                that.zkontrolujInitHlasku(NactiDto, NactiDto.InitHlaska2).done(function () {
                    that.zkontrolujInitDotaz(NactiDto).done(function () {
                        if (NactiDto.CloseForm) {
                            that.tryCloseOdemkni();
                        }
                        else if (NactiDto.SpustitPodani) {
                            that.spustitPodani();
                        }
                        else if (NactiDto.Odemknuto) {
                            that.zavolejNactiData(NactiDto);
                        }
                        else if (NactiDto.DotazPotvrzen && !NactiDto.JednaSeOOdpoved) {
                            NactiDto.JednaSeOOdpoved = true;
                            //znovu volam  naciti data
                            that.zavolejNactiData(NactiDto);
                        }
                        else {
                            that.tryCloseOdemkni();
                        }
                    });
                   
                });
            });

        }


        //#endregion

        // #region spustit podani
        /**
         * Start Podani
         */
        private spustitPodaniZnovu(): void{
            // inicializace
            this.VysledekSpustitPodaniDto = undefined;
            this.VysledekKrok1Call1 = undefined;
            this.VysledekKrok2Call = undefined;
            this.VysledekKrok3Call = undefined;
            this.VysledekKrok4Call = undefined;
            this.Krok4VysledekRucnihoOvereni = {};
            this.VysledekKrok5Call = undefined;
            this.Krok5VysledekFormu = {};
            this.VysledekKrok6Call = undefined;
            this.Krok6VysledekFormu = {};
            this.Krok6VysledekOdeslatPozvrzeni = undefined;
            this.VysledekVygenerovanaOdpoved = undefined;

            this.OrigEml = false;
            this.OrigEmlAddTST = false;

            this.resetVsehoOdKroku(0);

            this.PolePovolenychKroku = [false, false, false, false, false, false];

            if (this.$FormHlavicka != null && this.$FormHlavicka.length > 0) { this.$FormHlavicka.remove(); this.$FormHlavicka = undefined;}
            if (this.$FormHlavickaObsah != null && this.$FormHlavickaObsah.length > 0) { this.$FormHlavickaObsah.remove(); this.$FormHlavickaObsah = undefined; }
            if (this.$FormHlavickaObsahFade != null && this.$FormHlavickaObsahFade.length > 0) { this.$FormHlavickaObsahFade.remove(); this.$FormHlavickaObsahFade = undefined; }
            if (this.$FormHlavickaObsahText != null && this.$FormHlavickaObsahText.length > 0) { this.$FormHlavickaObsahText.remove(); this.$FormHlavickaObsahText = undefined; }
            if (this.$FormHlavickaDruha != null && this.$FormHlavickaDruha.length > 0) { this.$FormHlavickaDruha.remove(); this.$FormHlavickaDruha = undefined; }

            //(this.Wizard as any).currentContent.empty();
            this.aktivujKrok(1);

            this.zavolejSrvSpustitPodani();
        }
        
        private spustitPodani(): void {
            this.vytvoreniPruvodce();
            this.zavolejSrvSpustitPodani();

        }
        /**
         * zavolani funkce spustit podani
         */
        private zavolejSrvSpustitPodani(): void {
            const that: GEvidenceElPodaniDlg = this;

            this.call<Gordic.Pod.WebControls.GEvidenceElPodaniSpustPodaniDto>("SpustPodani", undefined, null/*, { progressState: { text: "jres:31950220" } }*//*, { progressState: "Načítám data" }*/).done(function (retVal) { //RC 31950220 : Načítám data
                if (retVal) {
                    that.spustitPodaniAfrerResponse(retVal);
                }
            });
        }
        /**
         * zpracování odpovědi z srv funkce "SpustPodani"
         * @param {Gordic.Pod.WebControls.GEvidenceElPodaniSpustPodaniDto} dto
         */
        private spustitPodaniAfrerResponse(dto: Gordic.Pod.WebControls.GEvidenceElPodaniSpustPodaniDto) {
            const that: GEvidenceElPodaniDlg = this;

            this.VysledekSpustitPodaniDto = dto;
            if (dto.ChyboveDto &&  this.IfCloseForm) { // doslo k chybe zavrit form
                this.ifCloseFormFunction(dto.ChyboveDto);
                return;
            }

            //setovani promenych
            this.EmailPuvodni = dto.EmailPuvodni;
            this.EmailProp = dto.EmailProp;


            //stavba hlavicky atd....
            this.postavHlavicku(dto);
            this.presunOvladaniPruvdce();
            //this.vytvoreniPruvodce();


            if (dto.ActionZobrazInfoOAntiviruEnabled) {
                this.actions["actInfoOAntiviru"].enabled(true);
            }

            if (dto.ActionRychlaOdpovedMailemVisible) {
                this.actions["actRychlaOdpoved"].visible(true);
            }

            this.actions.add(new GAction({
                name: "actDoubleClickGrid",
                caption: "jres:31950362", //RC 31950362 : Otevřít přílohu
                tooltip: "jres:31950363", //RC 31950363 : Otevře označenou přílohu v seznamu
                run: function (ev, obj) {
                    that.otevriNeboStahniSoubor(false);
                }
            }));
            this.actions.add(new GAction({
                name: "actStahnoutZpravu",
                caption: "jres:31950246", //RC 31950246 : Stáhnout přílohu
                tooltip: "jres:31950247", //RC 31950247 : Stáhne označenou přílohu v seznamu
                run: function (ev, obj) {
                    that.otevriNeboStahniSoubor(true);
                }
            }));
            this.actions.add(new GAction({
                name: "actStahnoutZip",
                caption: "jres:31950364", //RC 31950364 : Stáhnout všechny přílohy
                tooltip: "jres:31950364", //RC 31950364 : Stáhnout všechny přílohy
                run: function (ev, obj) {
                    that.stahniZipPodani();
                }
            }));
            this.zkontrolujHlasku(dto.HlaskaNepodariloSeZavestKontrolu, "jres:31950311") //RC 31950311 : Pozor
                .done(function () {
                    that.pokracuj();
                    that.OdemknoutPodaniAfterClose = true; // nevím zda má být zde nenbo kam to přesně říznout (čas ukáže)
                });
        }


        private otevriNeboStahniSoubor(pouzestahnout: boolean) {
            var that = this;
            if (Gordic.Utils.WidgetExists("ggrid", that.$Grid)) {
                var sel = that.$Grid.ggrid("getSelection");
                if (sel && sel.length > 0) {
                    var l_sFilePath: string | null = null;
                    l_sFilePath = sel[0].filePath;
                    that.log.trace("ActionZobrazSoubor_Start");
                    if (l_sFilePath) {
                        that.log.trace("ActionZobrazSoubor_Cesta: " + l_sFilePath);
                        that.stahniSoubor(l_sFilePath, pouzestahnout); //sel[0].jmenoSouboru,
                    }
                    that.log.trace("ActionZobrazSoubor_End");

                }
            }


        }

        /**
         * otestovani zda se nma form zavřit
         * @param {Gordic.Pod.WebControls.GEvidenceElPodaniChybovaHlaskaDto} chyboveDto
         */
        private ifCloseFormFunction(chyboveDto: Gordic.Pod.WebControls.GEvidenceElPodaniChybovaHlaskaDto) {
            const that: GEvidenceElPodaniDlg = this;
            if (this.IfCloseForm) {
                this.dialogs.warning("jres:31950144", chyboveDto.Hlaska).on("closed", function (ev, ret) { //RC 31950144 : Upozornění
                    if (ret) {

                        //TODo  v dto jsou pidy ktere je třeba asi otevřit
                        that.tryCloseOdemkni();

                        if (chyboveDto.Pid != null && chyboveDto.Pid.length > 0) {
                            that.otevriPostupnePoleDokumentu(chyboveDto.Pid,0);
                        }
                    }
                })
            }
        }

        private otevriPostupnePoleDokumentu(polePidu: string[], index: number) {
            var that = this;
            if (polePidu.length > index) {
                var options = {
                    DetailDto: { ixp: polePidu[index] }
                };
                Gordic.Wfl.Dialogs.DetailDokumentuSpisu(that.parentContent, options, Gordic.Global.Enums.ModOtevreni.navigate)
                    .done(function (cntDetail) {
                        if (cntDetail) {
                            cntDetail.on("closed",
                                function (ev, retValue) {
                                    index = index + 1;
                                    that.otevriPostupnePoleDokumentu(polePidu, index);
                                });
                        }
                    });
            }
        }

        /**
         * vytvoření hlavičky
         * @param {Gordic.Pod.WebControls.GEvidenceElPodaniSpustPodaniDto} dto
         */
        private postavHlavicku(dto: Gordic.Pod.WebControls.GEvidenceElPodaniSpustPodaniDto) {
            this.vybudujHlavickovyForm(dto);
            this.setniHlavickoveFormy(dto);
        }

        /**
         * vybuduje Hlavickovu Formu
         * 
         * @param {Gordic.Pod.WebControls.GEvidenceElPodaniSpustPodaniDto} dto
         */
        private vybudujHlavickovyForm(dto: Gordic.Pod.WebControls.GEvidenceElPodaniSpustPodaniDto) {
            const that: GEvidenceElPodaniDlg = this;
            // Formulář
            const formBuilderHlavickaZaklad = new Gordic.Forms.Form({
                name: "FormHlavicka1",
                layoutDescriptor: "L2M2S1",
                customClass: "js-podaniHlavicka"
            })
                .addSection({ layoutDescriptor: "L-0-12-0, M-0-12-0, S-0-12-0", customClass: "w-L-2 w-M-4 w-S-12 autohide" }) //
                .addRow() 
                .addField("gstringbox", {
                    name: "PodpisZpravy"
                })
                .addRow()
                .addField("gstringbox", {
                    name: "StavPodpisuZpravy"
                })

                .addSection({  customClass: "w-L-10 w-M-8 w-S-12" })
                .addRow("jres:23900010") //RC 23900010 : Způsob doručení
                .addField("gstringbox", {
                    name: "TbZpusobDoruceniTxt",
                })
                .addRow("jres:31950145") //RC 31950145 : Datum stažení
                .addField("gdatebox", {
                    name: "Dat_prij",
                    valueType: "datetime"
                })
                .addRow("jres:23900059") //RC 23900059 : Poznámka
                .addField("gstringbox", {
                    name: "Poznamka",
                });
               
            if (dto.IsZpDorTypuEDesk) {
                formBuilderHlavickaZaklad
                    .addSection() // 2
                    .addRow("jres:31950146") //RC 31950146 : Naše ČJ
                    .addField("gstringbox", {
                        name: "CjOdes",
                    })
                    .addRow("jres:31950147") //RC 31950147 : Vaše ČJ
                    .addField("gstringbox", {
                        name: "CjRec",
                    });
            }
              
            // Přidání formuláře do DOMu.
            this.$FormHlavicka = $("<div>").insertBefore((that.Wizard as any).gwizard_container).gform("createFrom", formBuilderHlavickaZaklad);

            //const formBuilderHlavickaZakladObsah = new Gordic.Forms.Form({
            //    name: "FormHlavicka1Obsah",
            //    layoutDescriptor: "L1M1S1 L-12-12-0 M-12-12-0 S-12-12-0",
            //}).addSection(dto.ObsahZpravy)
            //    .addRow()
            //    .addField("gstringbox", {
            //        name: "Obsah",
            //        rows: 5,
            //        disabled: true,
            //        buttons: [
            //            {
            //                icon: 'gi-detail',
            //                requireEdit: false,
            //                action: new GAction({
            //                    name: 'actOtevriDetail',
            //                    mujParam: 'test',
            //                    run: function (ev, ctx) {
            //                        //console.log("TODO Otevri detail na cele");
            //                        //TODO DSebesta nevím zda zde stačí otevírat EML
            //                        that.zobrazitZpravuEML();

            //                    }
            //                })
            //            }
            //        ],

            //    })
            //    ;

            //this.$FormHlavickaObsah = $("<div>").appendTo(that.element).gform("createFrom", formBuilderHlavickaZakladObsah);

            //article

            //const formBuilderHlavickaZakladObsah = new Gordic.Forms.Form({
            //    name: "FormHlavicka1Obsah",
            //    layoutDescriptor: "L1M1S1 L-12-12-0 M-12-12-0 S-12-12-0",
            //}).addSection(dto.ObsahZpravy);
            //$("<div>").appendTo(that.element).gform("createFrom", formBuilderHlavickaZakladObsah);

            //this.$FormHlavickaObsah = $("<div style='height:auto; max-height:250px; min-height:100px; overflow:auto; padding:0 0.5rem;'>").appendTo(this.element);// .height(300);
            
            this.$FormHlavickaObsah = $("<div class='elPod-Pruvodce-Obsah-tab'>").insertBefore((this.Wizard as any).gwizard_container)
                .append("jres:31950276") //RC 31950276 : Nedostupné
                ; // Bohouš
            //this.$FormHlavickaObsah.css("max-height", 400);
            //this.$FormHlavickaObsah.gautofit(
            //    {
            //        criticalHeight: 50,
            //    }
            //);
            this.$FormHlavickaObsah.gtab({
                title: dto.ObsahZpravy,
                opened: true,
                menuBar: [
                    {
                        favorite:true,
                        action: that.actions.add( new GAction({
                            name: "actObsahZobrazSkryj",
                            caption: "jres:31950274", //RC 31950274 : Zobrazit celý obsah
                            tooltip: "jres:31950275", //RC 31950275 : Zobrazí celý obsah zprávy
                            visible: false,
                            run: function (event) {
                                that.$FormHlavickaObsahText.toggleClass("elPod-Pruvodce-Obsah-text");
                                if (that.$FormHlavickaObsahText.hasClass("elPod-Pruvodce-Obsah-text")) {
                                    this.update({
                                        caption: "jres:31950277", //RC 31950277 : Zobrazit celý obsah
                                        tooltip: "jres:31950278" //RC 31950278 : Zobrazí celý obsah zprávy
                                    });
                                    that.$FormHlavickaObsahFade.show();

                                } else {
                                    this.update({
                                        caption: "jres:31950279", //RC 31950279 : Skrýt celý obsah
                                        tooltip: "jres:31950280" //RC 31950280 : Skryje celý obsah zprávy
                                    });
                                    that.$FormHlavickaObsahFade.hide();
                                }
                            }
                        }))
                    }
                ]
            });


            //this.$FormHlavickaObsah.garticle({
            //    id: "life",
            //    editable: false,
            //    //title: "jres:23900057", //RC 23900057 : Obsah
            //    content: "Nedostupné",
            //    //height: 300

            //});

            //$("<div>").appendTo(this.element).glink({
            //    params: {
            //        action: new GAction({
            //            name: "actMoreGlink",
            //            caption: "Zobrazit celý obsah",
            //            tooltip: "Zobrazí celý obsah zprávy",
            //            run: function (event) {
            //                that.$FormHlavickaObsah.removeClass("elPod-Obsah-Minimalizovano");
            //            }
            //        })
            //    }
            //});

            if (dto.IsZpDorTypuEDesk) {
                this.$FormHlavickaObsah.hide();
            }



            if (dto.IsZpDorTypuDatavaZprava) {
                const formBuilderHlavickaDatovka = new Gordic.Forms.Form({
                    name: "FormHlavicka2",
                    layoutDescriptor: "L3M2S1 L-4-8-0 M-4-8-0 L-12-12-0",
                    customClass: "js-podaniHlavicka2"
                })
                    .addSection() // 1
                    .addRow("jres:31950146") //RC 31950146 : Naše ČJ
                    .addField("gstringbox", {
                        name: "CjOdes",
                    })
                    .addRow("jres:31950148") //RC 31950148 : Sp. zn.
                    .addField("gstringbox", {
                        name: "SpZnOdes",
                    })
                    .addRow("jres:31950149") //RC 31950149 : ID. útvar
                    .addField("gstringbox", {
                        name: "IDUOdes",
                    })
                    .addRow("jres:31950150") //RC 31950150 : Útvar
                    .addField("gstringbox", {
                        name: "UOdes",
                    })

                    .addSection() // 2
                    .addRow("jres:31950147") //RC 31950147 : Vaše ČJ
                    .addField("gstringbox", {
                        name: "CjRec",
                    })
                    .addRow("jres:31950148") //RC 31950148 : Sp. zn.
                    .addField("gstringbox", {
                        name: "SpZnRec",
                    })
                    .addRow("jres:31950149") //RC 31950149 : ID. útvar
                    .addField("gstringbox", {
                        name: "IDUtvar",
                    })
                    .addRow("jres:31950150") //RC 31950150 : Útvar
                    .addField("gstringbox", {
                        name: "Utvar",
                    })

                    .addSection() // 3
                    .addRow("jres:31950151") //RC 31950151 : K rukám
                    .addField("gstringbox", {
                        name: "KRukam",
                    })
                    .addRow("jres:31950152") //RC 31950152 : Zákon (rok/číslo)
                    .addField("gstringbox", "w-6", {
                        name: "ZakonRok",
                    })
                    .addField("gstringbox", "w-6", {
                        name: "ZakonCislo",
                    })
                    .addRow("jres:31950153") //RC 31950153 : Paragraf
                    .addField("gstringbox", {
                        name: "Paragraf",
                    })
                    .addRow("jres:31950154") //RC 31950154 : Odstavec, písmeno
                    .addField("gstringbox", "w-6", {
                        name: "Odstavec",
                    })
                    .addField("gstringbox", "w-6", {
                        name: "Pismeno",
                    })
                    .addRow("jres:31950155") //RC 31950155 : Do vlastních r.
                    .addField("gcheck", {
                        name: "DoVlRukou",
                    })

                    ;
                // Přidání formuláře do DOMu.
                this.$FormHlavickaDruha = $("<div>").insertBefore((that.Wizard as any).gwizard_container).gform("createFrom", formBuilderHlavickaDatovka);
            }
        }

        /**
         * nastavi hodnoty do hlavičky
         * 
         * @param {Gordic.Pod.WebControls.GEvidenceElPodaniSpustPodaniDto} dto
         */
        private setniHlavickoveFormy(dto: Gordic.Pod.WebControls.GEvidenceElPodaniSpustPodaniDto) {
            const that: GEvidenceElPodaniDlg = this;
           
            this.setniObsahovePolicko(dto.Obsah);


            this.$FormHlavicka.findFields().gfield("model", "apply", dto);
            this.$FormHlavicka.gform("viewMode", "view");
            if (this.$FormHlavickaDruha) {
                this.$FormHlavickaDruha.findFields().gfield("model", "apply", dto);
                this.$FormHlavickaDruha.gform("viewMode", "view");
            }
        }

        private setniObsahovePolicko(Obsah: string): void {


            if (Obsah) { 
                //this.$FormHlavickaObsah.garticle("updateText", Obsah);
                this.vytvorPokudNeniObsahVeHlavicce();
                this.$FormHlavickaObsahText.html(Obsah);
            }
            // konec article

            this.Obsah = Obsah;
        }

        private vytvorPokudNeniObsahVeHlavicce(): void {

            if (this.$FormHlavickaObsahText == null) {
                this.$FormHlavickaObsah.html("");
                let wrp = $("<div>").appendTo(this.$FormHlavickaObsah);
                this.$FormHlavickaObsahFade = $("<div class='elPod-Pruvodce-Obsah-fade'>").appendTo(wrp); // Bohouš
                this.$FormHlavickaObsahText = $("<div class='elPod-Pruvodce-Obsah-text'>")// Bohouš
                    .appendTo(wrp)
                    ;
                this.actions.actObsahZobrazSkryj.visible(true);
            }
           

        }

        //#endregion


        // #region definice pruvodce
        /**
         * vytvoreni Pruvodce
         */
        private vytvoreniPruvodce(): void {
            const that: GEvidenceElPodaniDlg = this;

            // 03.01.2018 - TFeik
            // Oprava po prepsani Wizarda do TS, kde z něj je classa.
            that.Wizard = new Gordic.Wizard();
            /*Gordic*/that.Wizard.create(
                {
                    content: this // ... předání contentu do widgetu průvodce 
                },
                {
                    title: this.Title,
                    steps: [
                        {
                            caption: "jres:31950156", //RC 31950156 : Příjem podání
                            create: function (gcontent, contentDiv, change) {
                                var span = $("<span> jres:31950156 </span>"); //RC 31950156 : Příjem podání
                                span.appendTo(contentDiv);
                            },
                            change: function (gcontent, contentDiv, change) {
                                var span = $("<span> jres:31950157 </span>"); //RC 31950157 : Načítá se
                                span.appendTo(contentDiv);
                                that.zmenaStepu(change.task.nextStep);
                                change.stepsEnable = that.getPolePovolenychKroku();
                            }
                        },
                        {
                            caption: "jres:31950158", //RC 31950158 : Antivir. kontrola
                            create: function (gcontent, contentDiv, change) {
                                that.aktualniCisloKroku = 2;
                                if (that.Step2_MaAktualniDataProVykresleni) {
                                    let tab = $("<div>").appendTo(contentDiv).gtab({
                                        title: "jres:31950159", //RC 31950159 : Antivirová kontrola
                                        opened: true,
                                        menuBar: that.actions.createBar(["actStahnoutZpravu*", "actStahnoutZip*"])  //"actDoubleClickGrid*",  odstraněn z antivirové kontroly
                                    });
                                    let obsah = $("<div>").appendTo(tab);
                                    
                                    that.krok2_vykreslit(that.VysledekKrok2Call, obsah, change); //rovnou vykreslí
                                    
                                } else {
                                    that.krok2(that.nespoustetAutomatickyChod(2)); // aktivuje znovu načtení dat ze servru
                                }
                            },
                            change: function (gcontent, contentDiv, change) {
                                that.changeZKroku2(gcontent, contentDiv, change);
                                that.zmenaStepu(change.task.nextStep);
                                change.stepsEnable = that.getPolePovolenychKroku();

                            }
                        },
                        {
                            caption: "jres:31950160", //RC 31950160 : Rozbor podání
                            create: function (gcontent, contentDiv, change) {
                                that.aktualniCisloKroku = 3;
                                if (that.Step3_MaAktualniDataProVykresleni) {
                                    
                                    let tab = $("<div>").appendTo(contentDiv).gtab({
                                        title: "jres:31950160", //RC 31950160 : Rozbor podání
                                        opened: true,
                                        menuBar: that.actions.createBar(["actDoubleClickGrid*", "actStahnoutZpravu*", "actStahnoutZip*"]) 
                                    });
                                    let obsah = $("<div>").appendTo(tab);
                                    
                                    that.krok3_vykreslit(that.VysledekKrok3Call, obsah, change); //rovnou vykreslí
                                } else {
                                    that.krok3(that.nespoustetAutomatickyChod(3)); // aktivuje znovu načtení dat ze servru
                                }

                            },
                            change: function (gcontent, contentDiv, change) {
                                that.zmenaStepu(change.task.nextStep);
                               
                                change.stepsEnable = that.getPolePovolenychKroku();
                            }
                        },
                        {
                            caption: "jres:31950161", //RC 31950161 : Ověření podpisů
                            create: function (gcontent, contentDiv, change) {
                               
                                that.aktualniCisloKroku = 4;
                                if (that.Step4_MaAktualniDataProVykresleni) {
                                    let tab = $("<div>").appendTo(contentDiv).gtab({
                                        title: "jres:31950161", //RC 31950161 : Ověření podpisů
                                        opened: true,
                                        menuBar: that.actions.createBar(["actDoubleClickGrid*", "actStahnoutZpravu*", "actStahnoutZip*"]) 
                                    });
                                    let obsah = $("<div>").appendTo(tab);
                                    
                                    that.krok4_vykreslit(that.VysledekKrok4Call, obsah, change); //rovnou vykreslí
                                } else {
                                    that.krok4(that.nespoustetAutomatickyChod(4)); // aktivuje znovu načtení dat ze servru
                                }
                            },
                            change: function (gcontent, contentDiv, change) {
                                that.zmenaStepu(change.task.nextStep);
                               
                                change.stepsEnable = that.getPolePovolenychKroku();
                                that.krok4_konec(that.VysledekKrok4Call, contentDiv, change);
                               
                            }
                        },
                        {
                            commandBar: {
                                next: { caption: "jres:31950162"}, //RC 31950162 : Registrovat
                            },
                            caption: "jres:31950163", //RC 31950163 : Evidence
                            create: function (gcontent, contentDiv, change) {
                                that.aktualniCisloKroku = 5;
                                
                                if (that.Step5_MaAktualniDataProVykresleni) {
                                    let tab = $("<div>").appendTo(contentDiv).gtab({
                                        title: "jres:31950163", //RC 31950163 : Evidence
                                        opened: true,
                                        menuBar: that.actions.createBar(["actDoubleClickGrid*", "actStahnoutZpravu*", "actStahnoutZip*"]) 
                                    });
                                    let obsah = $("<div>").appendTo(tab);
                                    
                                    that.krok5_vykreslit(that.VysledekKrok5Call, obsah, change); //rovnou vykreslí
                                } else {
                                    that.krok5(that.nespoustetAutomatickyChod(5)); // aktivuje znovu načtení dat ze servru
                                }
                                that.element.resize();

                            },
                            change: function (gcontent, contentDiv, change) {
                                that.zmenaStepu(change.task.nextStep);
                                
                                change.stepsEnable = that.getPolePovolenychKroku();
                                that.krok5_konec(that.VysledekKrok4Call, contentDiv, change);
                                ;
                                if (change.task.taskOn === false && change.task.nextStep === 5) {
                                    (change as any).stepsCancel[5] = true;
                                    that.krok6(that.nespoustetAutomatickyChod(6));
                                }
                            }
                        },
                        {
                            caption: "jres:31950164", //RC 31950164 : Tvorba odpovědi
                            create: function (gcontent, contentDiv, change) {
                                that.aktualniCisloKroku = 6;
                                if (that.Step6_MaAktualniDataProVykresleni) {
                                    let tab = $("<div>").appendTo(contentDiv).gtab({
                                        title: "jres:31950164", //RC 31950164 : Tvorba odpovědi
                                        opened: true,
                                    });
                                    let obsah = $("<div>").appendTo(tab);

                                    that.PolePovolenychKroku[0] = false;
                                    that.PolePovolenychKroku[1] = false;
                                    that.PolePovolenychKroku[2] = false;
                                    that.PolePovolenychKroku[3] = false;
                                    that.PolePovolenychKroku[4] = false;
                                    
                                    that.krok6_vykreslit(that.VysledekVygenerovanaOdpoved, obsah, change); //rovnou vykreslí

                                    that.actions.actInfoOAntiviru.enabled(false);
                                    that.actions.actOdmitnoutZavirovano.enabled(false);
                                    that.actions.actOdmitnoutNesplnujeStandard.enabled(false);
                                    that.actions.actOdmitnoutNecitelne.enabled(false);
                                    that.actions.actRozeberMailVMailu.enabled(false);
                                } else {
                                    that.krok6(that.nespoustetAutomatickyChod(6)); // aktivuje znovu načtení dat ze servru
                                }
                            },
                            change: function (gcontent, contentDiv, change) {
                                change.stepsEnable = that.getPolePovolenychKroku();
                            },
                            
                        },

                        // ... další kroky
                    ],
                    complete: function (gcontent, contentDiv, change) {
                        
                        that.OdeslatPotvrzeni();
                        //gcontent.tryClose();
                    }
                });

            //this.presunOvladaniPruvdce();
        }

        private nespoustetAutomatickyChod(spoustenyKrok:number):boolean {
            var ret = true;
            if (spoustenyKrok > this.provedenoKroku  ) {
                ret = false;
            }

            return ret;

        }

        /**
         * hack pro presunuti ovládaní pruvodce až nad statickou hlavičku
         */
        private presunOvladaniPruvdce() {
            const that: GEvidenceElPodaniDlg = this;
            //gwizard__content
            //this.find(".js-podaniHlavicka").insertBefore(this.find(".gwizard__content"));

            this.find(".gwizard__steps").insertBefore(this.find(".js-podaniHlavicka"));
        }

        //#endregion


        //#region ovladaniKroku
        /**
         * obecny posun na další krok
         */
        private pokracuj():boolean {
            const that: GEvidenceElPodaniDlg = this;
            var ret = true;
            
            var _pokracujDalsimKrokem = this.aktualniCisloKroku >= this.provedenoKroku;

            // u zveřejnění se končí nejspíš v kroku 4 
            if (this.aktualniCisloKroku === 4 && this.VysledekKrok1Call1 && this.VysledekKrok1Call1.IsZverejneni) {
                _pokracujDalsimKrokem = false;
            }

            if (_pokracujDalsimKrokem) {
                this.aktualniCisloKroku = this.aktualniCisloKroku + 1;
                this.spustitKrok(this.aktualniCisloKroku);
            } else {
                ret = false;
            }
            return ret;

        }
        /**
         * spustit konkretni krok pruvodce
         * 
         * @param {number} krok
         */
        private spustitKrok(krok: number) {
            const that: GEvidenceElPodaniDlg = this;
            if (krok > this.provedenoKroku) this.provedenoKroku = krok;

            switch (krok) {
                case 1:
                    this.krok1();
                    break;
                case 2:
                    this.krok2();
                    break;
                case 3:
                    this.krok3();
                    break;
                case 4:
                    this.krok4();
                    break;
                case 5:
                    this.krok5();
                    break;
                default:
            }
        }


        //#endregion

        //#region Krok1
        /**
         * Start kroku1
         */
        private krok1() {
            const that: GEvidenceElPodaniDlg = this;

            this.krok1_callZaklad();

        }

        /**
         * zakladni call kroku 1 na aserver
         */
        private krok1_callZaklad() {
            const that: GEvidenceElPodaniDlg = this;
            var inputDto: Gordic.Pod.WebControls.GKrok1InputElEvidenceDto = {};
            inputDto.JeAntivir = this.VysledekSpustitPodaniDto.JeAntivir;
            inputDto.NoAntivir = this.VysledekSpustitPodaniDto.NoAntivir;
            inputDto.OrigEml = this.getOrigEml();
            inputDto.StavInb = this.VysledekSpustitPodaniDto.StavInb;
            inputDto.ZpusDor = this.VysledekSpustitPodaniDto.ZpusDor;
            inputDto.EmailProp = this.EmailProp;
            inputDto.ParamAV = this.VysledekSpustitPodaniDto.ParamAV;

            
            this.call<Gordic.Pod.WebControls.GKrok1ElEvidenceDto>("Krok1", { inputDto: inputDto }, null/*, { progressState: { text: "jres:31950221" } }*/)
                .done(function (retVal) { //RC 31950221 : Probíhá rozbor el. podání
                    if (retVal) {
                        that.krok1_callZakladDone(retVal);
                    }
                })
                .fail(function (xhr, type, vobj) {
                    if (vobj && vobj.baseType === "Gordic.Pod.Client.GPodDecodeException") {
                        that.tryCloseOdemkni(); // dsebesta T15936
                    }
                })
                ;
        }

        /**
         * zpracovani callu kroku 1
         * 
         * @param {Gordic.Pod.WebControls.GKrok1ElEvidenceDto} dto
         */
        private krok1_callZakladDone(dto: Gordic.Pod.WebControls.GKrok1ElEvidenceDto) {
            const that: GEvidenceElPodaniDlg = this;
            this.VysledekKrok1Call1 = dto;
         
            //setovani promenych
            if (dto.DZPole.EmailPuvodni) this.EmailPuvodni = dto.DZPole.EmailPuvodni;
            this.OrigEml = dto.OrigEml;

            if (dto.EmailProp) { // přenesená hodnota z DZ pole EmailPuvodni
                this.EmailProp = dto.EmailProp;
            }

            if (dto.ZpracovatJakoMsgInMsg) {
                this.ZpracovatJakoMsgInMsg = dto.ZpracovatJakoMsgInMsg;
            }

            //nastaveni akcí
            
            this.actions["actZobrazZpravu"].enabled(dto.BtZobrazZpravuEnabled);
           
            if (dto.ActionRozeberMailVMailuVisible) {
                this.actions["actRozeberMailVMailu"].visible(true);
            }
            
            this.zkontrolujKrok1DotazOdmitnuti(dto).done(function () {
                that.zkontrolujKrok1DotazPostoupeni(dto).done(function () {
                    that.zkontrolujHlasku(dto.ChyboveDto.Hlaska, "jres:31950144").done(function () { //RC 31950144 : Upozornění
                        that.zkontrolujHlasku(dto.ChyboveDto.Hlaska2, "jres:31950144").done(function () { //RC 31950144 : Upozornění
                            that.zkontrolujHlasku(dto.ChyboveDto.Hlaska3, "jres:31950144").done(function () { //RC 31950144 : Upozornění
                                that.zkontrolujHlasku(dto.ChyboveDto.ProblemFile, "jres:31950144").done(function () { //RC 31950144 : Upozornění
                                    //Hlaska3
                                    if (that.testIfCloseForm()) { return; } // pokud byl nastaven příznak na zavření někde.
                                    that.krok1_upravFormPodleDto(dto);


                                    // vykjreslím Iframe pro sk DATOVKY
                                    if (that.VysledekSpustitPodaniDto.IsZpDorTypuEDesk) {
                                        that.pridatIFRAME();
                                    }
                                    if (dto.VygenerovanaOdpoved) {
                                   
                                        that.zkontrolujHlasku(dto.VygenerovanaOdpoved.ChyboveDto.Hlaska2, "jres:31950144").done(function () { //RC 31950144 : Upozornění
                                            that.VysledekVygenerovanaOdpoved = dto.VygenerovanaOdpoved;
                                            that.Step6_MaAktualniDataProVykresleni = true;
                                            that.PIDDokumentu = dto.PIDDokumentu;
                                            that.krokx_setniIkonku(1, "fajfku");
                                            that.krokx_setniIkonku(2, "fajfku");
                                            that.krokx_setniIkonku(3, "fajfku");
                                            that.krokx_setniIkonku(4, "fajfku");
                                            that.krokx_setniIkonku(5, "fajfku");
                                        
                                            that.PolePovolenychKroku[5] = true;
                                            that.aktivujKrok(6);
                                        });


                                        //GEvidenceElPodaniGenerovatOdpovedDto

                                    }
                                    if (dto.ProvedTestZpracovani) {
                                        that.krokx_setniIkonku(1, "fajfku");
                                        that.testTypZpracovani(dto.IsPostoupeni, null);
                                    }
                                });
                            });
                        });
                    });
                });
            });
        }

        /**
         * vyvolá na serveru test na typ dalsiho zpracovaní
         * @param {boolean} IsPostoupeni
         * @param {Gordic.Pod.WebControls.GEvidenceElPodaniTypZpracovaniDto} callDto
         */
        private testTypZpracovani(IsPostoupeni: boolean, callDto: Gordic.Pod.WebControls.GEvidenceElPodaniTypZpracovaniDto) {
            const that: GEvidenceElPodaniDlg = this;
            if (IsPostoupeni) {
                this.rozeberMailVMailu();  //ZpracujZpravuVeZprave
            } else {
                if (callDto == null) {
                    var callDto: Gordic.Pod.WebControls.GEvidenceElPodaniTypZpracovaniDto = {};
                    callDto.ZpusDor = this.VysledekSpustitPodaniDto.ZpusDor;
                    callDto.CestaKEml = this.VysledekKrok1Call1.CestaKEml; // dsebesta 15.12.2021 -  this.VysledekSpustitPodaniDto.NoAntivir; 
                    callDto.ZpracovatJakoMsgInMsg = this.ZpracovatJakoMsgInMsg;
                }

                this.call<Gordic.Pod.WebControls.GEvidenceElPodaniTypZpracovaniDto>("TestTypZpracovani", { dto: callDto }, null/*, { progressState: { text: "jres:31950221" } }*/).done(function (retVal) { //RC 31950221 : Probíhá rozbor el. podání
                    if (retVal) {
                        var deffNelzePokracovat = $.Deferred();
                        if (retVal.Pokracuj) { // skok na dálší krok
                            that.PolePovolenychKroku[1] = true;
                            if (that.pokracuj()) {
                                deffNelzePokracovat.reject();

                            } else {
                                deffNelzePokracovat.resolve();
                            }
                        } else {
                            deffNelzePokracovat.resolve();
                        }

                        

                        deffNelzePokracovat.promise().done(function () {
                            if (retVal.ShowQuestion) {
                                that.dialogs.confirm("jres:23900067", retVal.Question).on("closed", function (ev, odpoved) { //RC 23900067 : Dotaz

                                    if (odpoved === "yes") {
                                        retVal.OdpovedUzivatele = true;
                                    } else {
                                        retVal.OdpovedUzivatele = false;
                                    }
                                    retVal.IsOdpoved = true;
                                    that.testTypZpracovani(IsPostoupeni, retVal);
                                })
                            } else if (retVal.IsOdpoved && retVal.HlaskaInfo) { //RC 31950018 : Odpověď na zveřejnění byla zpracována.
                                that.dialogs.messageBox("", retVal.HlaskaInfo).on("closed", function (ev, retVal) {
                                    if (that.testIfCloseForm()) { return; } // pokud byl nastaven příznak na zavření někde.
                                });

                            } else if (retVal.CloseAndOdemknout) {
                                that.dialogs.warning("Upozornění", retVal.HlaskaWarning).on("closed", function (ev, retVal) {
                                    that.tryCloseOdemkni();
                                });

                            }
                        });
                           

                    }
                });
            }

        }

        /**
         * upravé hlavičku podle výsledku z kroku 1
         * 
         * @param {Gordic.Pod.WebControls.GKrok1ElEvidenceDto} dto
         */
        private krok1_upravFormPodleDto(dto: Gordic.Pod.WebControls.GKrok1ElEvidenceDto) {
            const that: GEvidenceElPodaniDlg = this;
            //setovani polí dz
            this.UpravHodnotyPodleDZPole(dto.DZPole);
            this.setniHlavniIkonyOvereniPodpisu(dto.ImgPodpisuZpravy, dto.ImgPodpisuZpravyTxt, dto.ImgOvereniPodpisu, dto.ImgOvereniPodpisuTxt);
           
        }

        private UpravHodnotyPodleDZPole(dto: GEvidenceElPodaniDZpoleDto): void {
            this.findForms("FormHlavicka1,FormHlavicka2").findFields().gfield("model", "apply", dto);
            if (dto.Obsah) {
                this.setniObsahovePolicko(dto.Obsah);
            }
        }

       

        //#endregion

        //#region Krok2 

        /**
         * start kroku 2
         * 
         * @param {boolean} [manualClick]
         */
        private krok2(manualClick?: boolean) {
            const that: GEvidenceElPodaniDlg = this;
            this.krok2_callZaklad(manualClick);
        }

        /**
         * call krok2
         * 
         * @param {boolean} [manualClick]
         */
        private krok2_callZaklad(manualClick?: boolean) {
            const that: GEvidenceElPodaniDlg = this;
            var inputDto: Gordic.Pod.WebControls.GKrok2InputElEvidenceDto = {};

            inputDto.JeAntivir = this.VysledekSpustitPodaniDto.JeAntivir;
            inputDto.NoAntivir = this.VysledekSpustitPodaniDto.NoAntivir;
            inputDto.ZpusDor = this.VysledekSpustitPodaniDto.ZpusDor;
            inputDto.ParamAV = this.VysledekKrok1Call1.ParamAV;
            inputDto.OrigEml = this.getOrigEml();
            //inputDto.StavInb = this.VysledekSpustitPodaniDto.StavInb;
            //

            this.call<Gordic.Pod.WebControls.GKrok2ElEvidenceDto>("Krok2", { inputDto: inputDto, manualClick: manualClick }, null/*, { progressState: { text: "jres:31950222 dd" } }*/).done(function (retVal) { //RC 31950222 : Zpracovávám
                if (retVal) {
                    that.krok2_callZakladDone(retVal);
                }
            });
        }
        /**
         * zpracopvani call z korku 2
         * 
         * @param {Gordic.Pod.WebControls.GKrok2ElEvidenceDto} dto
         */
        private krok2_callZakladDone(dto: Gordic.Pod.WebControls.GKrok2ElEvidenceDto) {
            const that: GEvidenceElPodaniDlg = this;
            this.VysledekKrok2Call = dto;
            if (dto.ZavirovanoKrok2) { // mozna stačí rozskočit až ve vykreslení
                
                this.krok2_callZakladAktivujKrok(dto);
            }
            else if (dto.Pokracuj) {
                that.PolePovolenychKroku[2] = true;
                this.krokx_setniIkonku(2, "fajfku");
                if (!this.pokracuj()) {
                    this.krok2_callZakladAktivujKrok(dto);
                }
            }
            else {
                that.PolePovolenychKroku[2] = true;
                this.krok2_callZakladAktivujKrok(dto);
            }

        }
        private krok2_callZakladAktivujKrok(dto: Gordic.Pod.WebControls.GKrok2ElEvidenceDto) {
            this.OrigEml = dto.GridDto.OrigEml;
            this.Step2_MaAktualniDataProVykresleni = true;
            this.aktivujKrok(2);
        }

        // 03.01.2018 - TFeik
        // Oprava po prepsani Wizarda do TS, kde z něj je classa.
        /**
         * vykresleni obsahu kroku 2
         * 
         * @param {Gordic.Pod.WebControls.GKrok2ElEvidenceDto} dto
         * @param {JQuery<HTMLElement>} contentDiv
         * @param {Wizard.changeObject} change
         */
        private krok2_vykreslit(dto: Gordic.Pod.WebControls.GKrok2ElEvidenceDto, contentDiv: JQuery<HTMLElement>, change: /*Wizard.changeObject*/OGWizardChange) {
            const that: GEvidenceElPodaniDlg = this;
            this.resetActContinue();
            const formBuilder = new Gordic.Forms.Form({
                name: "FormKrok2",
                layoutDescriptor: "L1M1S1 L-0-12-0 M-0-12-0 S-0-12-0",
                customClass: "js-formKrok2"
            })
                .addSection()
                .addRow({ customClass: dto.NejsouViryVisible? "autohide" :"" })
                .addField("gcheck",  { 
                    name: "OrigEml",
                    label: "jres:31950165" //RC 31950165 : Originál je samotná zpráva
                })
                ;
            if (dto.NejsouViryVisible) {
                formBuilder.addRow() // { required: true }
                    .addField("gcheck", {
                        name: "NejsouViry",
                        label: "jres:31950236", //RC 31950236 : Soubory neobsahují viry
                        change: function (ev, chObj) {
                            if (chObj.value) {
                                that.NejsouViryValue = true;
                                that.krokx_setniIkonku(2, "fajfku");
                                that.pokracuj();
                              
                            } else {
                                that.NejsouViryValue = false;
                                that.krokx_setniIkonku(2, "krizek");
                                that.odmitnoutZavirovano()
                                
                            }
                           
                        }
                    });
            }
            $("<div>").appendTo(contentDiv).gform("createFrom", formBuilder);

            if (this.NejsouViryValue) {
                this.findFields("NejsouViry").gfield("setInitial", true);
            } else {
                this.findFields("NejsouViry").gfield("setInitial", false);
            }

            this.OrigEml = dto.GridDto.OrigEml;
            this.setOrigEml();
            this.enableOrigEml(dto.GridDto.OrigEmlEnabled);
            this.createGrid(dto.GridDto, contentDiv);
            
            if (dto.ZavirovanoKrok2) {
                this.actions.actOdmitnoutNesplnujeStandard.enabled(false);
                this.actions.actOdmitnoutNecitelne.enabled(false);
                this.actions.actZobrazZpravu.enabled(false);
                this.zkontrolujHlasku("jres:31950054" //RC 31950054 : Antivirová kontrola nalezla problém.
                    , "jres:31950055"); //RC 31950055 : Pozor
                //TODO zakazat akce (nazacatku kroku 2 v tezkem)
            }

            

        }

        private changeZKroku2(gcontent, contentDiv, change) {
            var that = this;
            if (this.VysledekKrok2Call.NejsouViryVisible && !that.NejsouViryValue && this.DuvodOdmitnuti == Interface.DuvodOdmitnutiElPodani.neurceno) {
                
                change.stepsCancel = [true, true, true, true, true, true];
                that.dialogs.warning("jres:31950055", //RC 31950055 : Pozor
                    "jres:31950237"); //RC 31950237 : Je nutné zkontrolovat a odsouhlasit, zda soubory neobsahují viry.
                //this.odmitnoutZavirovano();
            } 
        }
        //#endregion

        //#region Krok3 
        /**
         * start kroku 3
         * 
         * @param {boolean} [manualClick]
         */
        private krok3(manualClick?: boolean) {
            const that: GEvidenceElPodaniDlg = this;
           

            this.krok3_callZaklad(manualClick);
        }

        
        /**
         * call krok 3
         * 
         * @param {boolean} [manualClick]
         */
        private krok3_callZaklad(manualClick?: boolean) {
            const that: GEvidenceElPodaniDlg = this;
            var inputDto: Gordic.Pod.WebControls.GKrok3InputElEvidenceDto = {};

            inputDto.JeAntivir = this.VysledekSpustitPodaniDto.JeAntivir;
            inputDto.NoAntivir = this.VysledekSpustitPodaniDto.NoAntivir;
            inputDto.ZpusDor = this.VysledekSpustitPodaniDto.ZpusDor;
            inputDto.OrigEml = this.getOrigEml();
            //inputDto.OrigEml = false;  //TODO; // original je samotná zpráva
            //inputDto.StavInb = this.VysledekSpustitPodaniDto.StavInb;


            this.call<Gordic.Pod.WebControls.GKrok3ElEvidenceDto>("Krok3", { inputDto: inputDto, manualClick: manualClick }, null/*, { progressState: { text: "jres:31950222 cc" } }*/).done(function (retVal) { //RC 31950222 : Zpracovávám
                if (retVal) {
                    that.krok3_callZakladDone(retVal);
                }
            });
        }

        /**
         * zpracovani call 3
         * 
         * @param {Gordic.Pod.WebControls.GKrok3ElEvidenceDto} dto
         */
        private krok3_callZakladDone(dto: Gordic.Pod.WebControls.GKrok3ElEvidenceDto) {
            const that: GEvidenceElPodaniDlg = this;
            this.VysledekKrok3Call = dto;
            this.OrigEml = dto.OrigEml;
            this.setOrigEml();

            this.zkontrolujHlasku(dto.Hlasky.Hlaska, "jres:23900007").done(function () { //RC 23900007 : Podpis
                that.zkontrolujHlasku(dto.Hlasky.Hlaska2, "jres:23900007").done(function () { //RC 23900007 : Podpis
                    that.zkontrolujHlasku(dto.Hlasky.Hlaska3, "jres:23900007").done(function () { //RC 23900007 : Podpis

                        if (dto.ChybaVprilohach) {
                            that.PolePovolenychKroku[3] = false;
                            that.krokx_setniIkonku(3, "krizek");
                        } else {
                            that.PolePovolenychKroku[3] = true;
                            that.krokx_setniIkonku(3, "fajfku");
                        }
                        
                        if (dto.Pokracuj) {
                            //that.PolePovolenychKroku[3] = true;
                            //that.krokx_setniIkonku(3, "fajfku");
                            if (!that.pokracuj()) {
                                that.Step3_MaAktualniDataProVykresleni = true;
                                that.aktivujKrok(3);
                            }
                        } else {
                            that.Step3_MaAktualniDataProVykresleni = true;
                            that.aktivujKrok(3);
                        }
                    });
                });
            });
        }

        // 03.01.2018 - TFeik
        // Oprava po prepsani Wizarda do TS, kde z něj je classa.
        /**
         * vykresleni kroku 3
         * 
         * @param {Gordic.Pod.WebControls.GKrok3ElEvidenceDto} dto
         * @param {JQuery<HTMLElement>} contentDiv
         * @param {Wizard.changeObject} change
         */
        private krok3_vykreslit(dto: Gordic.Pod.WebControls.GKrok3ElEvidenceDto, contentDiv: JQuery<HTMLElement>, change: /*Wizard.changeObject*/OGWizardChange) {
            const that: GEvidenceElPodaniDlg = this;
            this.resetActContinue();
            const formBuilder = new Gordic.Forms.Form({
                name: "FormKrok3",
                layoutDescriptor: "L1M1S1 L-0-12-0 M-0-12-0 S-0-12-0",
                customClass: "js-formKrok3"
            })
                .addSection()
                .addRow()
                .addField("gcheck", "", {
                    name: "OrigEml",
                    label: "jres:31950165", //RC 31950165 : Originál je samotná zpráva
                    change: function (ev, ChObj) {
                        if (!ChObj.flags.manualSet) {
                            that.callOrigEmlZmena(ChObj.value);
                            that.resetVsehoOdKroku(4);
                        }
                    }
                })
                ;

            if (dto.OrigEmlAddTST && dto.OrigEmlAddTST.VisibleOrigEmlAddTST) {
                formBuilder
                    .addField("gcheck", "", {
                        name: "OrigEmlAddTST",
                        label: "jres:31950166" //RC 31950166 : Přidat časové razítko při uložení
                    });
            }

            $("<div>").appendTo(contentDiv).gform("createFrom", formBuilder);
            this.OrigEml = dto.GridDto.OrigEml;
            this.setOrigEml();
            this.enableOrigEml(dto.GridDto.OrigEmlEnabled);
            this.createGrid(dto.GridDto, contentDiv);

            //
            if (dto.OrigEmlAddTST && dto.OrigEmlAddTST.VisibleOrigEmlAddTST) {
                this.setOrigEmlAddTST(dto.OrigEmlAddTST.ChechedOrigEmlAddTST);
                this.enableOrigEmlAddTST(dto.OrigEmlAddTST.EnableOrigEmlAddTST);
            }

            if (this.DuvodOdmitnuti != Interface.DuvodOdmitnutiElPodani.neurceno) {
                console.log("TODO dodělat funkci SetStavNaOdmitnuti");
                //set stav ODMITNUTI TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!§§
            }

        }
        //#endregion


        //#region Krok4 
        /**
         * zacatek kroku 4
         * 
         * @param {boolean} [manualClick]
         */
        private krok4(manualClick?: boolean) {
            const that: GEvidenceElPodaniDlg = this;
            this.krok4_callZaklad(manualClick);
        }

        /**
         * zpracovani call 4 
         * 
         * @param {boolean} [manualClick]
         */
        private krok4_callZaklad(manualClick?: boolean) {
            const that: GEvidenceElPodaniDlg = this;
            var inputDto: Gordic.Pod.WebControls.GKrok4InputElEvidenceDto = {};

            inputDto.OrigEml = this.getOrigEml();
            inputDto.StavElPodani = this.VysledekKrok1Call1.StavElPodani;

            this.call<Gordic.Pod.WebControls.GKrok4ElEvidenceDto>("Krok4", { inputDto: inputDto, manualClick: manualClick }, null/*, { progressState: { text: "jres:31950223" } }*/) //RC 31950223 : Probíhá ověření podpisů
                .done(function (retVal) {
                    if (retVal) {
                        that.krok4_zkontroluPocetOriginalu(retVal);
                    }
                })
                .fail(function (retVal) {
                    //uz snad neni potřeba
                })
                ;
        }
        private krok4_zkontroluPocetOriginalu(dto: Gordic.Pod.WebControls.GKrok4ElEvidenceDto) {
            var that = this;
            if (dto.PocetOriginaluJeVetsi) {
                this.dialogs.confirm("jres:23900067", //RC 23900067 : Dotaz
                    "jres:31950234").on("closed", function (ev, retVal) { //RC 31950234 : Je označeno více originálů, chcete zprávu rozdělit a zpracovat podání jednotlivě?
                        if (retVal === "yes") {
                            that.call<Gordic.Gin.WebClient.GRetValDlg>("RozlozPodani", {}, null)
                                .done(function (retVal) { 
                                    if (retVal && retVal.StavBool) {
                                        that.ZavreniBezOtazky = true;
                                        that.tryClose();
                                    } else if (retVal && retVal.ErrorMessage) {
                                        that.dialogs.warning("jres:31950144", retVal.ErrorMessage);
                                    }
                                }
                            );
                        } else {
                            that.Step3_MaAktualniDataProVykresleni = false;
                            that.aktivujKrok(3);
                        }
                    })
            } else {
                this.krok4_callZakladDone(dto);
            }
        }


        private krok4_callZakladDone(dto: Gordic.Pod.WebControls.GKrok4ElEvidenceDto) {
            const that: GEvidenceElPodaniDlg = this;
            this.VysledekKrok4Call = dto;

            that.PolePovolenychKroku[4] = true;
            if (dto.NonFatalException) { // padne na nefatalni  vyjimku
                that.zkontrolujHlasku(dto.NonFatalException, "Pozor").done(function () {
                    
                    that.krokx_setniIkonku(4, "krizek");
                    that.PolePovolenychKroku[4] = true;
                    that.Step4_MaAktualniDataProVykresleni = true;
                    if (dto.Pokracuj) {
                        that.pokracuj();
                    } else {
                        that.aktivujKrok(4);
                    }
                });
            } else {
                that.Step4_MaAktualniDataProVykresleni = true;

                switch (dto.TypOvereniPodpisu) { // parametr 

                    case "automat":
                        that.PolePovolenychKroku[4] = true;
                        that.krokx_setniIkonku(4, "fajfku");
                        if (dto.Pokracuj) {
                            if (!that.pokracuj()) {
                                that.aktivujKrok(4);
                            }
                        } else {
                            that.aktivujKrok(4);
                        }
                        break;
                    case "rucni":

                        that.aktivujKrok(4);
                        break;
                    case "zadne":
                        that.krokx_setniIkonku(4, "bezOvereniPodpisu");
                        if (!that.pokracuj()) {
                            that.aktivujKrok(4);
                        }
                        break;
                }
            }
        }

        // 03.01.2018 - TFeik
        // Oprava po prepsani Wizarda do TS, kde z něj je classa.
        /**
         * krok 4 vykreslit
         * 
         * @param {Gordic.Pod.WebControls.GKrok4ElEvidenceDto} dto
         * @param {JQuery<HTMLElement>} contentDiv
         * @param {Wizard.changeObject} change
         */
        private krok4_vykreslit(dto: Gordic.Pod.WebControls.GKrok4ElEvidenceDto, contentDiv: JQuery<HTMLElement>, change: /*Wizard.changeObject*/OGWizardChange) {
            const that: GEvidenceElPodaniDlg = this;

            this.resetActContinue();
            if (this.VysledekKrok4Call.TypOvereniPodpisu === "rucni") {
                const formBuilderRucnikontrolka = new Gordic.Forms.Form({
                    name: "FormKrok4Rucni",
                    layoutDescriptor: "L2M2S1",
                    customClass: "js-formKrok4"
                })
                    //podpisy
                    .addSection("jres:31950167") //RC 31950167 : Ruční kontrola podpisů
                    .addRow()
                    .addField("gcheck", {
                        name: "JeSignRuc",
                        label: "Je e-podpis",
                        change: function (ev, ChObj) {
                            that.changeINRucniOvereniPodpisu();
                        }
                    })
                    .addRow()
                    .addField("gcheck", {
                        name: "JeOkSignRuc",
                        label: "jres:31950170", //RC 31950170 : E-podpis je platný
                        disabled: true,
                        change: function (ev, ChObj) {
                            that.changeINRucniOvereniPodpisu();
                        }
                    })
                    .addRow("jres:31950168") //RC 31950168 : Příznak verifikace
                    .addField("gselectbox", Gordic.Prefabs.Select.wflcver(), {
                        name: "PrizVerif",
                        model: "model.PrizVerif=value.priz_verif",
                        disabled: true,
                    })
                    .addRow("jres:31950169") //RC 31950169 : Stav verifikace
                    .addField("gselectbox", Gordic.Prefabs.Select.wflcsve(), {
                        name: "StavVerif",
                        model: "model.StavVerif=value.stav_verif",
                        disabled: true
                    })

                    //razitka
                    .addSection("jres:31950171") //RC 31950171 : Ruční kontrola razítek
                    .addRow()
                    .addField("gcheck", {
                        name: "JeCasRazRuc",
                        label: "jres:31950172", //RC 31950172 : Je časové razítko
                        change: function (ev, ChObj) {
                            that.changeINRucniOvereniRazitka();
                        }
                    })
                    .addRow()
                    .addField("gcheck", {
                        name: "JeOkCasRazRuc",
                        label: "jres:31950173", //RC 31950173 : Časové razítko je platné
                        disabled: true,
                        change: function (ev, ChObj) {
                            that.changeINRucniOvereniRazitka();
                        }
                    })
                    .addRow("jres:31950168") //RC 31950168 : Příznak verifikace
                    .addField("gselectbox", Gordic.Prefabs.Select.wflcver(), {
                        name: "PrizVerifCasRaz",
                        model: "model.PrizVerifCasRaz=value.priz_verif",
                        disabled: true
                    })
                    .addRow("jres:31950169") //RC 31950169 : Stav verifikace
                    .addField("gselectbox", Gordic.Prefabs.Select.wflcsve(), {
                        name: "StavVerifCasRaz",
                        model: "model.StavVerifCasRaz=value.stav_verif",
                        disabled: true
                    })
                    ;
                $("<div>").appendTo(contentDiv).gform("createFrom", formBuilderRucnikontrolka);

                this.findForms("FormKrok4Rucni").findFields().gfield("model", "apply", this.Krok4VysledekRucnihoOvereni, { initialValues: true });
                this.changeINRucniOvereniPodpisu();
                this.changeINRucniOvereniRazitka();

            }
            const formBuilder = new Gordic.Forms.Form({
                name: "FormKrok4",
                layoutDescriptor: "L1M1S1 L-0-12-0 M-0-12-0 S-0-12-0",
                customClass: "js-formKrok4"
            })
                .addSection()
                .addRow()
                .addField("gcheck", "", {
                    name: "OrigEml",
                    label: "jres:31950165" //RC 31950165 : Originál je samotná zpráva
                })
                ;

            if (this.VysledekKrok3Call.OrigEmlAddTST && this.VysledekKrok3Call.OrigEmlAddTST.VisibleOrigEmlAddTST) {
                formBuilder
                    .addField("gcheck", "", {
                        name: "OrigEmlAddTST",
                        label: "jres:31950166" //RC 31950166 : Přidat časové razítko při uložení
                    });
            }

            //dto.ButtonNextEnable
        
            $("<div>").appendTo(contentDiv).gform("createFrom", formBuilder);
            ;
            this.OrigEml = dto.GridDto.OrigEml;
            this.setOrigEml();
            this.enableOrigEml(dto.GridDto.OrigEmlEnabled);
            this.createGrid(dto.GridDto, contentDiv);

            //
            if (this.VysledekKrok3Call.OrigEmlAddTST && this.VysledekKrok3Call.OrigEmlAddTST.VisibleOrigEmlAddTST) {
                this.setOrigEmlAddTST(this.VysledekKrok3Call.OrigEmlAddTST.ChechedOrigEmlAddTST);
                this.enableOrigEmlAddTST(this.VysledekKrok3Call.OrigEmlAddTST.EnableOrigEmlAddTST);
            }
        }

        // 03.01.2018 - TFeik
        // Oprava po prepsani Wizarda do TS, kde z něj je classa.
        /**
         * ulozeni vysledku z kroku 4
         * 
         * @param {Gordic.Pod.WebControls.GKrok4ElEvidenceDto} dto
         * @param {JQuery<HTMLElement>} contentDiv
         * @param {Wizard.changeObject} change
         */
        private krok4_konec(dto: Gordic.Pod.WebControls.GKrok4ElEvidenceDto, contentDiv: JQuery<HTMLElement>, change: /*Wizard.changeObject*/OGWizardChange) {
            const that: GEvidenceElPodaniDlg = this;

            this.findForms("FormKrok4Rucni").findFields().gfield("model", "collect", this.Krok4VysledekRucnihoOvereni);
            this.saveOrigEml();
            this.saveOrigEmlAddTST();
        }

        /**
         * ovládání zaškrtávátek
         */
        private changeINRucniOvereniPodpisu() {
            var JeSignRuc = this.findFields("JeSignRuc");
            var JeOkSignRuc = this.findFields("JeOkSignRuc");
            var PrizVerif = this.findFields("PrizVerif");
            var StavVerif = this.findFields("StavVerif");

            //disable na hlavni check
            var tempBool = (JeSignRuc.gfield("getValue") ? false : true);
            JeOkSignRuc.gfield("option", "disabled", tempBool);
            PrizVerif.gfield("option", "disabled", tempBool);
            StavVerif.gfield("option", "disabled", tempBool);

            // pkud je sign ruc disabnu selboxy
            tempBool = ((JeSignRuc.gfield("getValue") && !JeOkSignRuc.gfield("getValue")) ? false : true);
            PrizVerif.gfield("option", "disabled", tempBool);
            StavVerif.gfield("option", "disabled", tempBool);

            if (JeOkSignRuc.gfield("getValue")) {
                PrizVerif.gfield("model", "apply", { PrizVerif: 10 });
                StavVerif.gfield("model", "apply", { StavVerif: 10 });
            }

            //ValidaceKroku4(); prskne fakfku do kroku
        }

        /**
         * ovládání zaškrtávátek
         */
        private changeINRucniOvereniRazitka() {
            var JeCasRazRuc = this.findFields("JeCasRazRuc");
            var JeOkCasRazRuc = this.findFields("JeOkCasRazRuc");
            var PrizVerifCasRaz = this.findFields("PrizVerifCasRaz");
            var StavVerifCasRaz = this.findFields("StavVerifCasRaz");

            //disable na hlavni check
            var tempBool = (JeCasRazRuc.gfield("getValue") ? false : true);
            JeOkCasRazRuc.gfield("option", "disabled", tempBool);

            // pkud je sign ruc disabnu selboxy
            tempBool = ((JeCasRazRuc.gfield("getValue") && !JeOkCasRazRuc.gfield("getValue")) ? false : true);
            PrizVerifCasRaz.gfield("option", "disabled", tempBool);
            StavVerifCasRaz.gfield("option", "disabled", tempBool);

            if (JeOkCasRazRuc.gfield("getValue")) {
                PrizVerifCasRaz.gfield("model", "apply", { PrizVerifCasRaz: 10 });
                StavVerifCasRaz.gfield("model", "apply", { StavVerifCasRaz: 10 });
            }

            //ValidaceKroku4(); prskne fakfku do kroku
        }

        //#endregion

        //#region Krok 5

        /**
         *  začátek kroku 5
         * 
         * @param {boolean} [manualClick]
         */
        private krok5(manualClick?: boolean) {
            const that: GEvidenceElPodaniDlg = this;
            this.krok5_callZaklad(manualClick);
        }
        
        /**
         * call krok 5
         * 
         * @param {boolean} [manualClick]
         */
        private krok5_callZaklad(manualClick?: boolean) {
            const that: GEvidenceElPodaniDlg = this;
            var inputDto: Gordic.Pod.WebControls.GKrok5InputElEvidenceDto = {};
            inputDto.OrigEml = this.getOrigEml();
            inputDto.ZpusDor = this.VysledekSpustitPodaniDto.ZpusDor;
            inputDto.EmailProp = this.EmailProp;
            inputDto.RucniOvereni = this.Krok4VysledekRucnihoOvereni;
            inputDto.IDUOdes = (this.findFields("IDUOdes").length > 0) ? this.findFields("IDUOdes").gfield("getValue") : undefined;
            inputDto.UOdes = (this.findFields("UOdes").length > 0) ? this.findFields("UOdes").gfield("getValue") : undefined;
            inputDto.HodZFormChecked = (this.Krok5VysledekFormu as any).HodZFormChecked;
            inputDto.HodZFormPdf = (this.Krok5VysledekFormu as any).HodZFormPdf;
            inputDto.UpozorneniNaNeexistujiciESU = this.UpozorneniNaNeexistujiciESU;
            inputDto.Obsah = this.getObsah();
            inputDto.IsMsgSigned = this.VysledekKrok1Call1.IsMsgSigned;
            inputDto.DZPole = this.VysledekKrok1Call1.DZPole;

            // RucniOvereni // pridetat texty do modelu k selectboxum
            //inputDto.ZpusDor
            //JeMoznePodani
            
            this.call<Gordic.Pod.WebControls.GKrok5ElEvidenceDto>("Krok5", { inputDto: inputDto, manualClick: manualClick }, null/*, { progressState: { id: "asd", text: "jres:31950222 bb" } }*/).done(function (retVal) { //RC 31950222 : Zpracovávám
                if (retVal) {
                    
                    that.krok5_callZakladDone(retVal);
                }
            });
        }

        /**
         * zpracovani callu 5
         * 
         * @param {Gordic.Pod.WebControls.GKrok5ElEvidenceDto} dto
         */
        private krok5_callZakladDone(dto: Gordic.Pod.WebControls.GKrok5ElEvidenceDto) {
            const that: GEvidenceElPodaniDlg = this;
            this.VysledekKrok5Call = dto;
            //ukladani promenych a stavu
            this.OdesIDDS = dto.OdesIDDS;
            this.OdpEmail = dto.OdpEmail;

            this.restartCacheReadru();

            this.zkontrolujHlasku(dto.Hlasky.Hlaska, "Podpis").done(function () {
                that.zkontrolujHlasku(dto.Odesilatel.Hlasky.Hlaska, "Podpis").done(function () { //  ESU info kanál nebyl nalezen v kartotéce ESU.
                    that.zkontrolujHlasku(dto.Odesilatel.Hlasky.Hlaska2, "Podpis").done(function () { //Není vyplněn externí subjekt. // Nepodařilo se dohledat externí subjekt.
                        if (that.testIfCloseForm()) { return; } // pokud byl nastaven příznak na zavření někde.
                        if (dto.VygenerovanaOdpoved && dto.VygenerovanaOdpoved.TextPotvrz) {
                            that.VysledekVygenerovanaOdpoved = dto.VygenerovanaOdpoved;
                            that.Step6_MaAktualniDataProVykresleni = true;
                            that.PolePovolenychKroku[5] = true;
                            that.krokx_setniIkonku(5, "fajfku");
                            that.aktivujKrok(6);
                            
                        } else { 

                            that.Step5_MaAktualniDataProVykresleni = true;
                            that.aktivujKrok(5);
                        }
                    });
                });
            });
        }

        // 03.01.2018 - TFeik
        // Oprava po prepsani Wizarda do TS, kde z něj je classa.
        /**
         * vykresleni kroku 5
         * 
         * @param {Gordic.Pod.WebControls.GKrok5ElEvidenceDto} dto
         * @param {JQuery<HTMLElement>} contentDiv
         * @param {Wizard.changeObject} change
         */
        private krok5_vykreslit(dto: Gordic.Pod.WebControls.GKrok5ElEvidenceDto, contentDiv: JQuery<HTMLElement>, change: /*Wizard.changeObject*/OGWizardChange) {
            const that: GEvidenceElPodaniDlg = this;
     
           // this.actions.actContinue.update({caption:"Registrovat"});
            const formBuilderPrijato = new Gordic.Forms.Form({
                name: "FormKrok5Prijato",
                layoutDescriptor: "L1M1S1",
                customClass: "js-formKrok5"
            })
                //podpisy
                .addSection("")
                .addRow()
                .addField("gradio", {
                    name: "StavEPODPrijato",
                    itemClass: "",
                    initialValue: 10,
                    radios: [
                        { value: 10, label: 'jres:31950174' }, //RC 31950174 : Přijato
                        { value: 20, label: 'jres:31950175' }, //RC 31950175 : Přijato bez podpisu
                        { value: 30, label: 'jres:31950176' }, //RC 31950176 : Přijato s nevalidním podpisem
                    ]
                })
            $("<div>").appendTo(contentDiv).gform("createFrom", formBuilderPrijato);

            var fieldPrijato = this.findForms("FormKrok5Prijato").findFields();
            fieldPrijato.gfield("model", "apply", this.VysledekKrok1Call1, { initialValues: true });
            if (this.VysledekKrok5Call.StavEPODPrijato !== Interface.StavEPODPrijato.neurceno) {
                fieldPrijato.gfield("model", "apply", this.VysledekKrok5Call, { initialValues: true });
            }
           
            const formBuilder = new Gordic.Forms.Form({
                name: "FormKrok5",
                layoutDescriptor: "L1M1S1",
                customClass: "js-formKrok5"
            })
                //podpisy
                .addSection("jres:31950177") //RC 31950177 : Odesílatel podání
                .addRow(dto.EmailLabelText)
                .addField("gstringbox", {
                    name: "Email",
                    disabled:true,
                    change: function (ev, ChObj) {
                        that.changeINRucniOvereniPodpisu();
                    }
                })
                .addRow("jres:31950178") //RC 31950178 : Dohledaný externí subjekt
                .addField("gselectbox", {
                    name: "subjekt",
                    change: function (ev, ChObj) {
                        that.ZmenaOdesilatele();
                    },
                    model: "model.Odesilatel.IxsEsu=value.ixs_esu; model.Odesilatel.OdesZastLic=value.lic; model.Odesilatel.OdesZastPor=value.por_zast",
                }, Gordic.Esu.Prefabs.vyberEsu({
                    typ: Gordic.Esu.Globals.Enums.TypZobrazeniKaroteka.SelectEsuOrZo,   // přidání prefabu možnost vyberu z karoteky  viz. níže (def 3)
                    Logovani: {
                        Ixp: (dto.Odesilatel.Ixp && dto.Odesilatel.Ixp) ? dto.Odesilatel.Ixp : '0000X0000003',               // zadání logovacích údaju je nutnost hlavně IXP
                        DuvodHledani: Gordic.Gin.Globals.Enums.DuvodHledaniEsu.zadaniOdesilatele, // vybrat z enumu
                        AktZnacka: 'aktZnacka',
                        DuvodHledaniTxt: ''
                    },

                }));
            if (dto.Odesilatel.InfoKanalVisible) {
                formBuilder
                    .addRow("jres:31950179") //RC 31950179 : Dotčený subjekt(info kanál)
                    .addField("gstringbox", {
                        name: "DotcSubjInfoKanal",
                        model: "model.Odesilatel.DotcSubjInfoKanal=value"
                    })
            }
            $("<div>").appendTo(contentDiv).gform("createFrom", formBuilder);

            this.findForms("FormKrok5").findFields().gfield("model", "apply", this.VysledekKrok5Call, { initialValues: true });

            if (dto.HodnotyZFormuVisible) {
                const formBuilderHodnoty = new Gordic.Forms.Form({
                    name: "FormKrok5Hodnoty",
                    layoutDescriptor: "L2M2S1",
                    customClass: "js-formKrok5"
                })
                formBuilderHodnoty
                    .addSection()
                    .addRow()
                    .addField("gcheck", "", {
                        name: "HodZFormChecked",
                        label: "jres:31950180" //RC 31950180 : Použít hodnoty z e-mailu
                    })
                    .addSection()
                    .addRow()
                    .addField("gcheck", "", {
                        name: "HodZFormPdf",
                        label: "jres:31950181" //RC 31950181 : Použít hodnoty z formuláře
                    }).addSection("jres:31950269") //RC 31950269 : Hodnoty
                    ;

                //var tabHodnooty = $("<div>").appendTo(contentDiv).gtab({
                //    title: "Hodnoty",
                //    opened: true,
                //});

                $("<div>").appendTo(contentDiv).gform("createFrom", formBuilderHodnoty);

                this.findForms("FormKrok5Hodnoty").findFields().gfield("model", "apply", this.VysledekKrok5Call, { initialValues: true });
                this.createGridVlastnosti(dto, contentDiv);
            }



            //this.OrigEml = dto.GridDto.OrigEml;
            //this.setOrigEml();
            //this.enableOrigEml(dto.GridDto.OrigEmlEnabled);


            //var tabHodnooty = $("<div>").appendTo(contentDiv).gtab({
            //    title: ,
            //    opened: true,
            //});
            const formBuilderSoubory = new Gordic.Forms.Form({
                name: "FormKrok5Prazdnej",
                layoutDescriptor: "L1M1S1 L-0-12-0 M-0-12-0 S-0-12-0",
                customClass: "js-formKrok5"
            }).addRow()
                .addField("gcheck", "", {
                    name: "OrigEml",
                    label: "jres:31950165" //RC 31950165 : Originál je samotná zpráva
                });
           
            if (this.VysledekKrok5Call.OrigEmlAddTST && this.VysledekKrok5Call.OrigEmlAddTST.VisibleOrigEmlAddTST) {
                formBuilderSoubory
                    .addField("gcheck", "", {
                        name: "OrigEmlAddTST",
                        label: "jres:31950166" //RC 31950166 : Přidat časové razítko při uložení
                    });
            }

            formBuilderSoubory
                .addSection(
                    that.MultiSelectAddCasRaz ?
                        "jres:31950182" //RC 31950182 : Soubory podání - označte, k čemu přidat časové razítko
                        :"jres:31950021" //RC 31950021 : Soubory podání
            ); 
            $("<div>").appendTo(contentDiv).gform("createFrom", formBuilderSoubory);

            if (this.VysledekKrok5Call.OrigEmlAddTST && this.VysledekKrok5Call.OrigEmlAddTST.VisibleOrigEmlAddTST) {
                this.setOrigEmlAddTST(this.VysledekKrok5Call.OrigEmlAddTST.ChechedOrigEmlAddTST);
                this.enableOrigEmlAddTST(this.VysledekKrok5Call.OrigEmlAddTST.EnableOrigEmlAddTST);
            }


            this.OrigEml = dto.GridDto.OrigEml;
            this.setOrigEml();
            this.enableOrigEml(dto.GridDto.OrigEmlEnabled);


            this.createGrid(dto.GridDto, contentDiv);

            if (this.PouzePrehled === true) {
                this.actions.actContinue.update({ visible: false });
            }


            this.SetniHlavniIkonyOvereniPodpisuZKroku5(dto.ImgPodpisuZpravy, dto.ImgPodpisuZpravyTxt, dto.ImgOvereniPodpisu, dto.ImgOvereniPodpisuTxt);
            
            this.element.resize();
        }

        // 03.01.2018 - TFeik
        // Oprava po prepsani Wizarda do TS, kde z něj je classa.
        /**
         * ulozeni vysledku z kroku 5
         * 
         * @param {Gordic.Pod.WebControls.GKrok5ElEvidenceDto} dto
         * @param {JQuery<HTMLElement>} contentDiv
         * @param {Wizard.changeObject} change
         */
        private krok5_konec(dto: Gordic.Pod.WebControls.GKrok5ElEvidenceDto, contentDiv: JQuery<HTMLElement>, change: /*Wizard.changeObject*/OGWizardChange) {
            const that: GEvidenceElPodaniDlg = this;

            this.findForms("FormKrok5Prijato,FormKrok5,FormKrok5Hodnoty").findFields().gfield("model", "collect", this.Krok5VysledekFormu);
            
            this.saveVybraneSoubory();
            this.saveOrigEml();
            this.saveOrigEmlAddTST();

            var zastxtVal = this.findFields("subjekt").gfield("getValue");
            this.ZastTxt = zastxtVal ? (zastxtVal.zast_txt as string) : null; // subjekt tpor_zast
            ;
            if (this.PouzePrehled !== true) {

                this.PolePovolenychKroku[5] = true;
            } else if (change.task.nextStep !== 4 && change.task.nextStep !== 5   ) {
                this.actions.actContinue.update({ visible: true });
            }
        }

        /**
         * ZmenaOdesilatele
         */
        private ZmenaOdesilatele() {
            const that: GEvidenceElPodaniDlg = this;
            
            let ZpusDor = this.VysledekSpustitPodaniDto.ZpusDor;

            let dtoOdesilatel: { Odesilatel: GOdesilatelElEvidenceDto} = {
                Odesilatel: null,
                
            };
            this.findFields("subjekt").gfield("model", "collect", dtoOdesilatel);

            dtoOdesilatel.Odesilatel.EmailPuvodni = this.EmailPuvodni;

            this.call<Gordic.Pod.WebControls.GOdesilatelElEvidenceDto>("ZmenaOdesilatele", { inputDto: dtoOdesilatel.Odesilatel, ZpusDor: ZpusDor }, null/*, { progressState: { text: "jres:31950222 aaa" } }*/).done(function (retVal) { //RC 31950222 : Zpracovávám
               
                that.zkontrolujHlasku(retVal.Hlasky.Hlaska, "jres:31950144").done(function () { //RC 31950144 : Upozornění
                    if (retVal.DosloKeZmenenVEmailPropOdesIDDSEmail) {
                        that.EmailProp = retVal.EmailProp;
                        that.OdesIDDS = retVal.OdesIDDS;
                        //that.Email = retVal.Email;
                        that.findFields("Email").gfield("setValue", retVal.Email);

                        //setnout polička
                    } else if (retVal.DosloKeZmenenVEmailPropOdpEmailEmail) {
                        that.EmailProp = retVal.EmailProp;
                        that.OdpEmail = retVal.OdpEmail;
                        //that.Email = retVal.Email;
                        that.findFields("Email").gfield("setValue", retVal.Email);
                        //setnout polička
                    }
                });
              
            });


        }

        //#endregion 

        //#region Krok 6
        /**
         * začátek kroku 6
         * 
         * @param {boolean} [manualClick]
         */
        private krok6(manualClick?: boolean) {
            const that: GEvidenceElPodaniDlg = this;
           
            that.krok6_callUpravitMailOdesilatele(manualClick);
        }

        /**
         * upravení mailu odesílatele
         * 
         * @param {boolean} [manualClick]
         */
        private krok6_callUpravitMailOdesilatele(manualClick?: boolean) {
            const that: GEvidenceElPodaniDlg = this;
            var ZpusDor = this.VysledekSpustitPodaniDto.ZpusDor;
            var VyberEsuValue = (this.Krok5VysledekFormu as any).Odesilatel;  //this.findFields("subjekt").gfield("getValue") || {};
            var IxsEsu = VyberEsuValue ? VyberEsuValue.IxsEsu: null;
            var PorZast = VyberEsuValue ? VyberEsuValue.OdesZastPor: null;

            var emailProp = this.EmailProp;

            this.ZkusUpravutMailOdesilatele(ZpusDor, IxsEsu, PorZast, emailProp)
                .done(function (retValMail) {
                    that.krok_6KontrolaNaTypDokumentuNeurcenoCiziPisemnostElPodani(manualClick);
                }
            );
        }

        /**
         * krok_6 Kontrola Na Typ Dokumentu Neurceno Cizi Pisemnost El Podani
         * 
         * @param {boolean} [manualClick]
         */
        private krok_6KontrolaNaTypDokumentuNeurcenoCiziPisemnostElPodani(manualClick?: boolean) {
            const that: GEvidenceElPodaniDlg = this;
            this.KontrolaNaTypDokumentuNeurcenoCiziPisemnostElPodani().done(function (retValMail) {
                that.krok6_callZaklad(manualClick);
            });
        }

        /**
         * krok 6 call na server
         * 
         * @param {boolean} [manualClick]
         */
        private krok6_callZaklad(manualClick?: boolean) {
            const that: GEvidenceElPodaniDlg = this;
            var inputDto: Gordic.Pod.WebControls.GKrok6InputElEvidenceDto = {};
            inputDto.ZpusDor = this.VysledekSpustitPodaniDto.ZpusDor;
            inputDto.OrigEml = this.getOrigEml();
            inputDto.TypPis = this.typPis;
            inputDto.StavEPODPrijato = this.Krok5VysledekFormu.StavEPODPrijato;
            inputDto.Obsah = this.getObsah();
            inputDto.HodZFormChecked = (this.Krok5VysledekFormu as any).HodZFormChecked;
            inputDto.EmailProp = this.EmailProp;
            inputDto.IDUOdes = (this.findFields("IDUOdes").length > 0) ? this.findFields("IDUOdes").gfield("getValue") : undefined;
            inputDto.UOdes = (this.findFields("UOdes").length > 0) ? this.findFields("UOdes").gfield("getValue") : undefined;
            inputDto.HodZFormPdf = (this.Krok5VysledekFormu as any).HodZFormPdf;
            inputDto.UpozorneniNaNeexistujiciESU = this.UpozorneniNaNeexistujiciESU;
            inputDto.IxsTypForm = this.VysledekKrok5Call ? this.VysledekKrok5Call.IxsTypForm: null;

            inputDto.ZastTxt = this.ZastTxt; // subjekt tpor_zast

            inputDto.DZPole = this.VysledekKrok1Call1.DZPole;
            if ((this.Krok5VysledekFormu as any).Odesilatel) {
                inputDto.DotcSubjInfoKanal = (this.Krok5VysledekFormu as any).Odesilatel.DotcSubjInfoKanal        
            }
          
            inputDto.Odesilatel = this.getValueOdesilatel();

             
            inputDto.ChechedOrigEmlAddTST = this.getOrigEmlAddTST();
            inputDto.VybraneSoubory = this.getVybraneSoubory();

            this.call<Gordic.Pod.WebControls.GKrok6ElEvidenceDto>("Krok6", { inputDto: inputDto, manualClick: manualClick }, null/*, { progressState: { text: "jres:31950224" } }*/) //RC 31950224 : Generuji odpověď
                .done(function (retVal) {    //RC 23900354 : Generuji odpověď
                    if (retVal) {
                        that.krok6_callZakladDone(retVal);
                    }
                });
        }

        /**
         * krok6_callZakladDone
         * 
         * @param {Gordic.Pod.WebControls.GKrok6ElEvidenceDto} dto
         */
        private krok6_callZakladDone(dto: Gordic.Pod.WebControls.GKrok6ElEvidenceDto) {
            const that: GEvidenceElPodaniDlg = this;
            this.VysledekKrok6Call = dto;
            if (dto.Stoped) {
                that.zkontrolujHlasku(dto.Hlasky.Hlaska, "jres:31950144").done(function () { //RC 31950144 : Upozornění
                    //asi bez reakce;
                });
                return;
            } else if (dto.ChyboveDto && dto.ChyboveDto && dto.ChyboveDto.IfCloseForm) { // doslo k chybe zavrit form
                this.ifCloseFormFunction(dto.ChyboveDto);
                return;
            }

            if (dto.Odesilatel) {
                that.zkontrolujHlasku(dto.Odesilatel.Hlasky.Hlaska, "jres:31950144"); //RC 31950144 : Upozornění
                if (dto.OdesilatelNedopadl) {
                    that.zkontrolujHlasku(dto.Odesilatel.Hlasky.Hlaska2, "jres:31950144"); //RC 31950144 : Upozornění
                    that.aktivujKrok(5);
                    return;
                }
            }

            this.zkontrolujHlasku(dto.Hlasky.Hlaska, "jres:31950144").done(function () { //RC 31950144 : Upozornění
                that.zkontrolujHlasku(dto.Hlasky.Hlaska2, "jres:31950144").done(function () { //RC 31950144 : Upozornění
                    that.zkontrolujHlasku(dto.Hlasky.HlaskaVytezitMetadataZObrazu, "jres:31950144").done(function () { //RC 31950144 : Upozornění
                        if (that.testIfCloseForm()) { return; }

                        if (dto.NeniOznacenOriginal) {
                            return ; // souvusi s hlaskou hlaska
                        }else if (dto.Stoped) {
                            return; // souvusi s hlaskou hlaska
                        }else if (dto.StornoPodani) {  //souvusi s hlaskou2 a ifCloseForm 
                            //stornovat
                            that.ZobrDetCbxValue = false; 
                            that.ZobrDetCbxDisable = true; 
                        }

                        if (!dto.StornoPodani) {
                            that.krokx_setniIkonku(5, "fajfku");
                        }

                        // pokud byl nastaven příznak na zavření někde.
                        that.Step6_MaAktualniDataProVykresleni = true;
                  
                    

                        that.VysledekVygenerovanaOdpoved = dto.VygenerovanaOdpoved;
                        that.PIDDokumentu = dto.PIDDokumentu;
                    
                        if (dto.SpustitOpravuPodani && dto.PIDDokumentu) {
                            that.beginOperation();
                            Gordic.Pod.Dialogs.PodaniOpravaPisemnostiDlg(that, {
                                Ixp: dto.PIDDokumentu,
                                ModFormu: Interface.ModFormuPodaniEnum.EditacePoElPodani,
                                TypPid: Wfl.Interface.TypPid.jizEvidovanyDokSpis
                            }).done(function (retValPodaniOpravaPisemnostiDlg: any) {

                                var optAktualizovatVygenerovanouOdpoved = {
                                    inputOdpovedDto: {
                                        ZpusDor: that.VysledekSpustitPodaniDto.ZpusDor,
                                        IsZverejneni:that.VysledekKrok1Call1.IsZverejneni,
                                        EmailProp: that.EmailProp
                                    },
                                    DZPole: that.VysledekKrok1Call1.DZPole

                                };
                                that.call("AktualizovatVygenerovanouOdpoved", optAktualizovatVygenerovanouOdpoved).done(function (retValAktualizovatVygenerovanouOdpoved) {
                                    that.VysledekVygenerovanaOdpoved = retValAktualizovatVygenerovanouOdpoved;
                                    if (retValPodaniOpravaPisemnostiDlg != null && retValPodaniOpravaPisemnostiDlg.textInformace != null) {
                                        that.showFlash(retValPodaniOpravaPisemnostiDlg.textInformace, "success", "InfoZOpravyDokumentu");
                                    }
                                    Gordic.Pod.Utils.TiskPodacihoRazitka(retValPodaniOpravaPisemnostiDlg.tiskPodacihoRazitka, that, that.PIDDokumentu).done(function () {
                                        if (dto.NabidkaKonverze === 1) {
                                            //console.log("TODO Jirka Dodělá dialog NabidkaKonverze()    GUniversalWflListTab   ");
                                            var SelectedRowsInfo: Wfl.Interface.SelectedRowInfoDto = { Ixp: dto.PIDDokumentu };
                                            var ListSelectedRowsInfo: Wfl.Interface.SelectedRowInfoDto[] = [];
                                            ListSelectedRowsInfo.push(SelectedRowsInfo);
                                            Gordic.Ssl.Utils.SouboryVNearchFormatu(that, ListSelectedRowsInfo) //Wfl.Interface.SelectedRowInfoDto
                                                .done(function (rv) {
                                                    if (rv.groupResult) {
                                                        var isErr = false;
                                                        for (var i = 0; i < rv.groupResult.length; i++) {
                                                            if (rv.groupResult[i].IsError) {
                                                                isErr = true;
                                                                break;
                                                            }
                                                        }
                                                        if (!isErr) {
                                                            //  that.dialogs.alert("jres:26256945"); //RC 26256945 : Nebyly nalezeny žádné soubory s nearchivním formátem. Pokud je kontrolován spis, nebyly kontrolovány přílohy dokumentů ve spisu vložených.
                                                        }
                                                    }
                                                })
                                                .always(function () {
                                                    that.endOperation();
                                                    that.aktivujKrok(6);
                                                });
                                            //that.aktivujKrok(6);
                                        } else {
                                            that.endOperation();
                                            that.aktivujKrok(6);
                                        }
                                    });
                                });
                           
                            });


                        } else {
                            that.aktivujKrok(6);
                            if (that.testIfCloseForm()) { return; } 
                        }
                  
                    });
                });
            });
        }

        // 03.01.2018 - TFeik
        // Oprava po prepsani Wizarda do TS, kde z něj je classa.
        /**
         * krok6  vykreslit obsah
         * 
         * @param {Gordic.Pod.WebControls.GEvidenceElPodaniGenerovatOdpovedDto} dto
         * @param {JQuery<HTMLElement>} contentDiv
         * @param {Wizard.changeObject} change
         */
        private krok6_vykreslit(dto: Gordic.Pod.WebControls.GEvidenceElPodaniGenerovatOdpovedDto, contentDiv: JQuery<HTMLElement>, change: /*Wizard.changeObject*/OGWizardChange) {
            const that: GEvidenceElPodaniDlg = this;
            
            if (dto.ActionTiskPruvodky) {
                this.actions["actTiskPruvodky"].visible(true);
                this.X0000 = dto.X0000;
                this.X0001 = dto.X0001;
                this.X0002 = dto.X0002;
            }
            var isInerniVypraveni = dto.ZpusDor === Wfl.Interface.TypPrijmuPodani.InterniVypraveni;
           

            const formBuilder = new Gordic.Forms.Form({
                name: "FormKrok6",
                layoutDescriptor: "L2M2S1",
                customClass: "js-formKrok6"
            })
                //podpisy
                .addSection()
                .addRow("jres:31950183") //RC 31950183 : PID dokumentu
                .addField("gstringbox", {
                    name: "PIDDokumentu",
                    disabled: true
                })
                .addRow()
                .addField("gcheck", {
                    name: "PisCbx",
                    label: "jres:31950184", //RC 31950184 : Písemně
                    change: function (ev, ChObj) {
                        if (ChObj.value) {
                            that.CbxChange();
                        }
                        that.cbxKontrolaZaskrtnutehoAsponNeodesilat();
                    },
                    disabled: isInerniVypraveni
                })
                .addRow()
                .addField("gcheck", {
                    name: "EmailCbx",
                    label: "jres:31950185", //RC 31950185 : E-mailem
                    change: function (ev, ChObj) {
                        if (ChObj.value) {
                            that.CbxChange();
                        }
                        that.cbxKontrolaZaskrtnutehoAsponNeodesilat();
                    },
                    disabled: isInerniVypraveni
                })
                .addRow()
                .addField("gcheck", {
                    name: "DSCbx",
                    label: "jres:31950186", //RC 31950186 : Dat. schránkou
                    change: function (ev, ChObj) {
                        if (ChObj.value) {
                            that.CbxChange();
                        }
                        that.cbxKontrolaZaskrtnutehoAsponNeodesilat();
                    },
                    disabled: isInerniVypraveni
                })
                .addRow()
                .addField("gcheck", {
                    name: "NoCbx",
                    label: "jres:23900077", //RC 23900077 : Neodesílat
                    change: function (ev, ChObj) {
                        if (ChObj.value) {
                            that.findFields("PisCbx").gfield("setValue", false);
                            that.findFields("EmailCbx").gfield("setValue", false);
                            that.findFields("DSCbx").gfield("setValue", false);
                           
                        }
                        that.cbxKontrolaZaskrtnutehoAsponNeodesilat();
                    }
                })
                //sekce 2
                .addSection()

                .addRow("jres:23900017") //RC 23900017 : Adresát
                .addField("gselectbox", {
                    name: "subjekt",
                    change: function (ev, ChObj) {
                        // that.ZmenaOdesilatele();
                    },
                    model: "model.OdesIxs=value.ixs_esu; model.OdesZastLic=value.lic; model.OdesZastPor=value.por_zast",
                }, Gordic.Esu.Prefabs.vyberEsu({
                    typ: Gordic.Esu.Globals.Enums.TypZobrazeniKaroteka.SelectEsuOrZo,   // přidání prefabu možnost vyberu z karoteky  viz. níže (def 3)
                    Logovani: {
                        Ixp: that.Ixp,               // zadání logovacích údaju je nutnost hlavně IXP
                        DuvodHledani: Gordic.Gin.Globals.Enums.DuvodHledaniEsu.zadaniOdesilatele, // vybrat z enumu
                        AktZnacka: 'aktZnacka',
                        DuvodHledaniTxt: ''
                    },

                }))
                .addRow("jres:31950032") //RC 31950032 : E-mail
                .addField("gstringbox", {
                    name: "OdpEmail",
                })
                .addRow()
                .addField("gcheck", {
                    name: "EmailSignCbx",
                    label: "jres:23900074", //RC 23900074 : Podepsat
                    disabled: !that.initDto.emailSignCbxEnable,
                    initialValue: that.initDto.emailSignCbxChecked
                })
                .addRow("jres:31950187") //RC 31950187 : DS
                .addField("gstringbox", {
                    name: "OdesIDDS",
                })
                .addRow("jres:31950188") //RC 31950188 : Odeslat z DS
                .addField("gselectbox", {
                    name: "DSOdDropDownField",
                    tooltip: dto.DSOdDropDown.Tooltip,
                    itemTemplate: "{mailbox_txt}",
                    data: new Gordic.Data.View(dto.DSOdDropDown.Data, { key: "mailbox" }) //, 
                })
                .addRow()
                .addField("gcheck", {
                    name: "ZobrDetCbx",
                    label: "jres:31950189", //RC 31950189 : Po dokončení průvodce zobrazit detail dokumentu
                })
                ;



            $("<div>").appendTo(contentDiv).gform("createFrom", formBuilder);
           
            if (dto.DSOdDropDown.SelectedValue) {
                this.findFields("DSOdDropDownField").gfield("setValue", { mailbox: dto.DSOdDropDown.SelectedValue }, { valid: false });
            }
           
            var fildyForm6 = this.findForms("FormKrok6").findFields();
            fildyForm6.gfield("model", "apply", dto, { initialValues: true });
            this.findFields("PIDDokumentu").gfield("setValue", that.PIDDokumentu);
            if (dto.DSCbx || dto.EmailCbx || dto.PisCbx) {
                this.CbxChange();
            }
            if (dto.NoCbx == false && dto.DSCbx == false && dto.EmailCbx == false) { // neproběhlo nastavení checboxu z modelu použiju z inicializace
                // 
                switch (that.VysledekSpustitPodaniDto.ZpusobOdeslaniPotvrzeni) {
                    case Interface.ZpusobOdeslaniPotvrzeni.neodesilat:
                        that.findFields("NoCbx").gfield("setValue", true);
                        break;
                    case Interface.ZpusobOdeslaniPotvrzeni.Email:
                        
                        that.findFields("EmailCbx").gfield("setValue", true);
                        break;
                    case Interface.ZpusobOdeslaniPotvrzeni.DZ:
                        that.findFields("DSCbx").gfield("setValue", true);
                        break;
                    case Interface.ZpusobOdeslaniPotvrzeni.GEX:
                        that.findFields("DSCbx").gfield("setValue", true);
                        break;
                    case Interface.ZpusobOdeslaniPotvrzeni.pisemne:
                        that.findFields("PisCbx").gfield("setValue", true);
                        break;
                    default:
                        that.findFields("NoCbx").gfield("setValue", true);
                        break;
                } 
            }
            this.cbxKontrolaZaskrtnutehoAsponNeodesilat(); // dsebesta přidána kontrola, na pojmenování závěrečné akce

            const formBuilderText = new Gordic.Forms.Form({
                name: "FormKrok6Text",
                layoutDescriptor: "L1M1S1 L-0-12-0 M-0-12-0 S-0-12-0 ",
            })

                //podpisy
                .addSection("jres:31950190") //RC 31950190 : Text souboru potvrzení
                .addRow()
                .addField("gstringbox", {
                    name: "TextPotvrz",
                    rows: 15,
                    disabled: true,
                    buttons: [
                        {
                            icon: "gi-pencil",
                            tooltip: "jres:31950191", //RC 31950191 : Editovat text soubopru potvrzení.
                            requireEdit:false,
                            action: new GAction({
                                name: 'actEditovatText',
                                run: function (ev, ctx) {
                                    var field = $(ctx.field);
                                    field.gfield("option", "disabled", !field.gfield("option", "disabled"));
                                    
                                }
                            })
                        },
                     ],

                });

            $("<div>").appendTo(contentDiv).gform("createFrom", formBuilderText);
            var fildyForm6Text = this.findForms("FormKrok6Text").findFields();
            fildyForm6Text.gfield("model", "apply", dto, { initialValues: true });
            that.ZobrDetCbxValue = this.PodElPodaniSettings.PoElPodaniZobrazitDetailDokumentu; 
            this.setZobrDetCbx();

            if (dto.PodaniByloZaregistrovano) {
                var flash = $("<div>").prependTo(contentDiv)
                flash.gflashpanel(({ label: "jres:31950192", noClose: true, customClass: Gordic.Gin.Globals.Enums.ColorStateClass.success }) as any) //RC 31950192 : Podání bylo zaregistrováno
            } else if (dto.PodaniByloOdmitnuto) {
                var flash = $("<div>").prependTo(contentDiv)
                flash.gflashpanel(({ label: "jres:31950193" + dto.PodaniByloOdmitnuto, noClose: true, customClass: Gordic.Gin.Globals.Enums.ColorStateClass.error}) as any) //RC 31950193 : Podání bylo odmítnuto z důvodu :
            }

            this.ZavreniBezOtazky = true; // mohu zavírat okno bez otazky. 
            this.element.resize();
        }
        private setZobrDetCbx() {
            var field = this.findFields("ZobrDetCbx");
            if (field && field.length > 0) {
                field.gfield("setValue", this.ZobrDetCbxValue);
                field.gfield("option", "disabled", this.ZobrDetCbxDisable);
            }
        }

        private CbxChange() {
           
            this.findFields("NoCbx").gfield("setValue", false);
            if (this.actions.actComplete) {
                this.actions.actComplete.update({ caption: "jres:31950194" }); //RC 31950194 : Odeslat
            }
           
        }

        private cbxKontrolaZaskrtnutehoAsponNeodesilat() {
            var that = this;
            if (!this.findFields("PisCbx").gfield("getValue") && !this.findFields("EmailCbx").gfield("getValue") && !this.findFields("DSCbx").gfield("getValue")){
                this.findFields("NoCbx").gfield("setValue", true);
                if (this.actions.actComplete) {
                    this.actions.actComplete.update({ caption: "Dokončit" });
                }
            }
        }

        /**
         * oprava mailu odesilatele
         * 
         * @param {Interface.TypPrijmuPodani} ZpusDor
         * @param {string} IxsEsu
         * @param {number} porZast
         * @param {string} emailProp
         * @returns {JQuery.Promise<void>}
         */
        private ZkusUpravutMailOdesilatele(ZpusDor: Wfl.Interface.TypPrijmuPodani, IxsEsu: string, porZast: number, emailProp: string): JQuery.Promise<void> {
            const that: GEvidenceElPodaniDlg = this;
            let promisek = $.Deferred();
            //pokud je email odesilatel v kartotéce ESU jiný (nebo není eveden) nabídne update
            if ((ZpusDor === Wfl.Interface.TypPrijmuPodani.EMail) && (IxsEsu != null)) {
                var opt: any = {};
                opt.ixsEsu = IxsEsu;
                opt.porZast = porZast;
                opt.emailProp = emailProp;
                opt.odpoved= null;

                this.call("UpravMailESUOdesilatele", opt).done(function (retVal) {
                    if (retVal.Message) { // vyvolat otázku
                        that.dialogs.confirm("jres:23900067", retVal.Message).on("closed", function (ev, retVal) { //RC 23900067 : Dotaz
                            if (retVal === "yes") { // odpoved na otázku
                                opt.odpoved = "yes"
                                that.call("UpravMailESUOdesilatele", opt).done(function (retVal) {
                                    if (retVal.StavBool) { // ozázka a call
                                        promisek.resolve();
                                    } else {
                                        promisek.reject();
                                    }
                                });
                            } else {
                                promisek.resolve();
                            }
                        });
                    } else {
                        promisek.resolve();
                    }
                });
            } else {
                promisek.resolve();
            }
            return promisek.promise();
        }

        /**
         * KontrolaNaTypDokumentuNeurcenoCiziPisemnostElPodani
         * 
         * @returns {JQuery.Promise<void>}
         */
        private KontrolaNaTypDokumentuNeurcenoCiziPisemnostElPodani(): JQuery.Promise<void> {
            const that: GEvidenceElPodaniDlg = this;
            let promisek = $.Deferred();
           
            
            var tempbool = false;
            //this.VysledekKrok5Call ? this.VysledekKrok5Call.IxsTypForm: null;
            //this.typPis = this.globalSettings.get("Global.Pod.AppSettings.PodElPodaniSettings.IxsTypDok");
        
            this.typPis = this.PodElPodaniSettings.IxsTypDok;
            //Global.Pod.AppSettings.PodDefaultSettings.TypPis
            //Global.Pod.AppSettings.PodElPodaniSettings.IxsTypDok
            if (this.ssl_typd_neurpo == 0) {
               
                if (
                    (this.typPis == null || this.typPis == "" || this.typPis === this.typPisNeurceno)
                    && this.VysledekKrok5Call.IxsTypForm == null // dsebesta 30.0.2023 přidáno kuli SK
                )
                {
                    tempbool = true;
                } 
            }
            if (tempbool && that.DuvodOdmitnuti == Interface.DuvodOdmitnutiElPodani.neurceno) { //dsebesta 10.12.2019 
                new Gordic.Data.Selectors.DefaultSelector($.extend(true, Gordic.Data.Selectors.sslstyp(), { parentElement: that.element, related: that.element })).show()
                    .then(function (retVal) {
                        let retTyp: Gordic.Data.Readers.SslstypDto = null;

                        if (Array.isArray(retVal)) {
                            retTyp = retVal[0];
                        } else {
                            retTyp = retVal;
                        }
                        that.typPis = retTyp.ixs_typ;
                        promisek.resolve();
                    });
                
            } else {
                promisek.resolve();

            }

            return promisek.promise();
        }

        /**
         * getValueOdesilatel
         * 
         * @returns {GOdesilatelElEvidenceDto}
         */
        private getValueOdesilatel():GOdesilatelElEvidenceDto {
            const that: GEvidenceElPodaniDlg = this;
            let odesilatelDto: GOdesilatelElEvidenceDto = {};

            var field = this.findFields("subjekt");
            if (field.length === 1) {
                var tempObj:any = {};
                field.gfield("model", "collect", tempObj);
                if (tempObj) {
                    odesilatelDto = tempObj.Odesilatel;
                }
            }

            return odesilatelDto;
        }

        private saveModelFromKork6() {
            this.findFields().gfield("model", "collect", this.Krok6VysledekFormu);

        }
        //#endregion


        //#region pomocneFunkce 
        /**
         * get dat obsah
         * 
         * @returns {string}
         */
        private getObsah(): string {
            //return this.findFields("Obsah").gfield("getValue");
            return this.Obsah;
        }

        /**
         * nastavení ikon k založkám pruvodce
         * 
         * @param {number} krok
         * @param {"nic" | "fajfku" | "bezOvereniPodpisu"} typ
         */
        private krokx_setniIkonku(krok: number, typ: "nic" | "fajfku" | "bezOvereniPodpisu" | "krizek") {
            switch (typ) {
                case "fajfku":
                    // 03.01.2018 - TFeik
                    // Oprava po prepsani Wizarda do TS, kde z něj je classa.
                    /*Gordic*/this.Wizard.removeIcon(this, krok - 1, undefined);
                    /*Gordic*/this.Wizard.setIcon(this, krok - 1, {
                        name: "gi gi-tick g-state-text g-state-success"
                    });
                    break;
                case "krizek":
                    // 03.01.2018 - TFeik
                    // Oprava po prepsani Wizarda do TS, kde z něj je classa.
                    /*Gordic*/this.Wizard.removeIcon(this, krok - 1, undefined);
                    /*Gordic*/this.Wizard.setIcon(this, krok - 1, {
                        name: "gi gi-window-close g-state-text g-state-important"
                    });
                    break;
                case "bezOvereniPodpisu":
                    // 03.01.2018 - TFeik
                    // Oprava po prepsani Wizarda do TS, kde z něj je classa.
                    /*Gordic*/this.Wizard.removeIcon(this, krok - 1, undefined);
                    /*Gordic*/this.Wizard.setIcon(this, krok - 1, {
                        name: "gi gi-circle",
                        tooltip: "jres:31950195" //RC 31950195 : Žádné ověření podpisu
                    });
                    break;
                case "nic":
                    // 03.01.2018 - TFeik
                    // Oprava po prepsani Wizarda do TS, kde z něj je classa.
                    /*Gordic*/this.Wizard.removeIcon(this, krok - 1, undefined);
            }
        }
        /**
         * aktivace kroku 
         * 
         * @param {number} cislo
         */
        private aktivujKrok(cislo: number) {
            // 03.01.2018 - TFeik
            // Oprava po prepsani Wizarda do TS, kde z něj je classa.
            /*Gordic*/this.Wizard.setStep(cislo - 1);
        }

        /**
         * setnutí checkboxu origeml
         */
        private setOrigEml() {
            var fieldOrigEml = this.findFields("OrigEml");
            this.findFields("OrigEml").gfield("setValue", this.OrigEml, { manualSet: true });
            if (this.VysledekKrok1Call1.OrigEmlHide) {
                
                fieldOrigEml.gformrow().hide();
            }
        }


        //OrigEml
        private saveOrigEml() {
            var field = this.findFields("OrigEml");
            if (field.length === 1) {
                this.OrigEml = field.gfield("getValue");
            }
        }
        private getOrigEml(): boolean {
            this.saveOrigEml();
            return this.OrigEml;
        }

        private enableOrigEml(val: boolean) {
            var disabled = !val
            if (this.PouzePrehled) {
                disabled = true;
            }
            this.findFields("OrigEml").gfield("option", "disabled", disabled);
        }

        //OrigEmlAddTST
        private setOrigEmlAddTST(val: boolean) {
            
            this.findFields("OrigEmlAddTST").gfield("setValue", val);
        }

        private enableOrigEmlAddTST(val: boolean) {
            var disabled = !val
            if (this.PouzePrehled) {
                disabled = true;
            }
            this.findFields("OrigEmlAddTST").gfield("option", "disabled", disabled);
        }

        private saveOrigEmlAddTST() {
            var field = this.findFields("OrigEmlAddTST");
            if (field.length === 1) {
                this.OrigEmlAddTST = field.gfield("getValue");
            }
        }
        private getOrigEmlAddTST(): boolean {
            this.saveOrigEmlAddTST();
            return this.OrigEmlAddTST;
        }

        /**
         * ulozeni vyběru z gridu
         */
        private saveVybraneSoubory() {
            if (this.$Grid && this.$Grid.hasClass("ggrid") && this.MultiSelectAddCasRaz) {
                var soubory = this.$Grid.ggrid("getSelection", false, true);
                this.VybraneSoubory = soubory;
            } else {
                this.VybraneSoubory = [];
            }
        }

        /**
         * get vybranych radku z gridu
         * 
         * @returns {Pod.Interface.GElPodaniPrilohyStrukturovaneDto[]}
         */
        private getVybraneSoubory(): Pod.Interface.GElPodaniPrilohyStrukturovaneDto[]{
            this.saveVybraneSoubory();
            return this.VybraneSoubory;
            
        }

        /**
         * get vsechny radku z gridu
         * 
         * @returns {Pod.Interface.GElPodaniPrilohyStrukturovaneDto[]}
         */
        private getVsechnyRadky(): Pod.Interface.GElPodaniPrilohyStrukturovaneDto[] {

            return this.ViewGridu.getDataRows(false);

        }

        /**
         * geter pro povolene kroky
         */
        private getPolePovolenychKroku() {
            if (this.PouzePrehled && this.VysledekKrok1Call1 !=null && this.VysledekKrok1Call1.IsZverejneni) {
                return [false, true, true, true, false, false];
            }
            else if (this.PouzePrehled) {
                return [false,true,true,true,false,true];
            }
            else { 
                return this.PolePovolenychKroku;
            }
        }


       /**
         * funkce pro zavírání formu, pod podmínkou dojde k odemčení podání
         * 
         * @returns {JQuery.Promise<void>}
         */
        private CloseForm(): JQuery.Promise<void> {
            const that: GEvidenceElPodaniDlg = this;
            let promisek = $.Deferred();
            // this.OdemknoutPodaniAfterClose
            if (!this.IsFormClosed  ) {
                this.IsFormClosed = true;
                this.callCloasingFormSrv() // zda odemknout formík
                    .done(function (retVal) {
                        promisek.resolve();
                    }).fail(function (retVal) {
                        promisek.reject();
                    })
                    ;
            } else {
                promisek.reject();
            }
            return promisek.promise();
        }

        /**
         * nastavení labelu akce na defaultní hodnotu
         */
        private resetActContinue() {
            this.actions.actContinue.update({ caption: "jres:31950248" }); //RC 31950248 : Další
        }
        /**
         * call na server pro odemknutí podání
         * 
         * @param {boolean} OdemknoutPodaniAfterClose
         * @returns {JQuery.Promise<void>}
         */
        private callCloasingFormSrv(): JQuery.Promise<void> {
            const that: GEvidenceElPodaniDlg = this;
            let promisek = $.Deferred();
            this.call<Gordic.Gin.WebClient.GRetValDlg>("CloasingForm").done(function (retVal) {
                if (retVal && retVal.StavBool) {
                    //cloasing proveden
                    promisek.resolve();
                } else {
                    promisek.reject();
                }
            });
            return promisek.promise();
        }

        /**
         * test zda se má zavřír form
         * 
         * @returns {boolean}
         */
        private testIfCloseForm(): boolean {
            if (this.IfCloseForm) {
                this.ZavreniBezOtazky = true;
                this.tryClose();
                return true;
            } else {
                return false;
            }
        }

        /**
         * zavření a nastavení parametru pro odemknutí podání
         */
        private tryCloseOdemkni() {
            this.OdemknoutPodaniAfterClose = true;
            this.ZavreniBezOtazky = true;
            this.tryClose();
        }

        // spustění zavírání
        private closing(): JQuery.Promise<void> {
            const that: GEvidenceElPodaniDlg = this;
            let promisOdemknuti = $.Deferred();

            this.OpravduZavritOkno().done(function () {
                var objRetFromDialog = {
                    zobrazitDetailPozavreniPruvodce: that.ZobrDetCbxChecked(),
                    pidDokumentu: that.PIDDokumentu
                };

                that.CloseForm().done(function (retVal) {
                    promisOdemknuti.resolve(objRetFromDialog);
                }).fail(function (retVal) {
                    promisOdemknuti.reject();
                });



            }).fail(function () {
                promisOdemknuti.reject();
            });
         
            return promisOdemknuti;
        }

        private OpravduZavritOkno(): JQuery.Promise<any, any, any> {
            let promisQuestion = $.Deferred();
            if (!this.ZavreniBezOtazky) {

                this.dialogs.confirm("jres:31950002", //RC 31950002 : Zavřít
                    "jres:31950258") //RC 31950258 : Opravdu si přejete zavřít okno elektronického podání?
                    .on("closed", function (ev, retVal) {
                        if (retVal === "yes") {
                            promisQuestion.resolve();
                        } else {
                            //Neodmítnout
                            promisQuestion.reject();
                        }
                    })
            } else {
                promisQuestion.resolve();
            }
            return promisQuestion.promise();
        }

        private ZobrDetCbxChecked(): boolean {
            var ret = false;
            var ZobrDetCbx = this.findFields("ZobrDetCbx");
            if (ZobrDetCbx && ZobrDetCbx.length > 0 ) {
                ret = ZobrDetCbx.gfield("getValue");
            }
            return ret;
        }
       
        private createGrid(gridDto: Gordic.Pod.WebControls.GElEvidenceGridDto, contentDiv: JQuery<HTMLElement> ) {
            var columns = this.definiceColumnsDoGridu(gridDto);
            //gridDto.Label label gridu // TODO zatím nevím kam ho prásknout
            this.PoleGridu = gridDto.Data;
            this.ViewGridu = new Gordic.Data.View(gridDto.Data, { key: "" });
            this.MultiSelectAddCasRaz = gridDto.MultiSelectAddCasRaz;
            this.$Grid = $("<div>").appendTo(contentDiv)
                .ggrid({
                    name: "GridElPodani",
                    data: this.ViewGridu,
                    renderMode: "auto", // auto, all-at-once, paged-sync, paged-async
                    columnMode: "fit",  // fit, full
                    multi: this.MultiSelectAddCasRaz,
                    //rowsClass: function (row, trueColumns, rowIndex) {
                    //    if (row.data.ixs_esu === row.data.ixs_eko) {
                    //        return "bold";
                    //    }
                    //},
                    //  navigationMode: "row", // row, cell
                    defaultAction: this.aktualniCisloKroku === 2 ? this.actions.actStahnoutZpravu : this.actions.actDoubleClickGrid,
                    // multi: true,

                    // scrollHelperTemplate: "{typ_adr_txt}-{esu_txt}",  // "{ixs_esu} - {nazev}",
                    // searchColumns: ["esu_txt"],
                    columns: columns,
                    //rowsChecked: "checked", //checked @checked
                    //rowsEnabled: function (row) {
                    //    var ret = true;
                    //    if (row && row.data && row.data.disableRow) {
                    //        ret = false;
                    //    }
                    //    return ret;
                    //}
                    rowsChecked: "IsChecked", //checked @checked
                    rowsEnabled: function (row) {
                        var ret = true;
                        if (row && row.data && row.data.IsDisabled) {
                            ret = false;
                        }
                        return ret;
                    }
                });
        }

        

        private definiceColumnsDoGridu(gridDto: Gordic.Pod.WebControls.GElEvidenceGridDto): Gordic.Data.GridFormat {
            const that: GEvidenceElPodaniDlg = this;
            var definiceFormu = new Gordic.Data.GridFormat();

            if (this.aktualniCisloKroku === 3 && this.PouzePrehled !== true ) {
                (definiceFormu as any).addLinksColumn({
                    links: function (row) {
                        let params = that.getMenuForRow(row);
                        return params;
                    }
                })
            }

            definiceFormu
                .addTextColumn({
                    name: "jmenoSouboru",
                    caption: "jres:31950196", //RC 31950196 : Jméno souboru
                    cellTemplate: function (row): string {
                        var ret = ""
                        if (row.jmenoSouboru) { ret = row.jmenoSouboru; }
                        var ret = ret.replace(/ /g, "&nbsp;");
                        return ret;
                    },
                });
            definiceFormu
               .addIconColumn({
                   width: 50,
                    name: "zarazenJako",
                    caption: "jres:31950330", //RC 31950330 : Zařazen jako
                    iconTemplate: function (data) {
                        var typ = Gordic.Pod.GPodFunction.GetTypZarazeniElSouboruByPriznak(data.zarazenJako);
                        return Gordic.Pod.GPodFunction.GetGIconDefinitionTypZarazeniElSouboru(typ);
                    }
               })
                .addIconColumn({
                    name: "zpracovatJakoPrilohu",
                    caption: "jres:31950331", //RC 31950331 : Samostatná příloha
                    tooltipTemplate: "jres:31950332", //RC 31950332 : Zpracovat jako samostatnou přílohu
                    iconTemplate: function (data) {
                        if (data["zpracovatJakoPrilohu"]) {
                            return Gordic.Pod.GPodFunction.GetGIconZpracovatJakoSamostatnouPrilohu();
                        }
                        return null;
                    }
                })
                .addTextColumn({
                    name: "zarazenJakoText",
                    caption: "jres:31950198" //RC 31950198 : Zařazen jako
                })
                
               .addIconColumn({
                    width:50,
                    name: "antivirovaKontrola",
                    caption: "jres:31950333", //RC 31950333 : Antivirová kontrola
                    iconTemplate: function (data) {
                        let enumik: Gordic.Wfl.Interface.WflcavkEnum = Gordic.Wfl.Interface.WflcavkEnum.neurceno;
                        if (data["prizAntivir"]) {
                            enumik = parseInt(data["prizAntivir"]);
                        }
                        var ico = Gordic.Pod.GPodFunction.GetGIconDefinitionPrizAntivir(enumik);
                        return ico;
                    }
                })
               .addIconColumn({
                    width: 50,
                    name: "registredFile",
                    caption: "jres:31950199", //RC 31950199 : Typ souboru
                   iconTemplate: function (data) {
                       if (data && data.problem) {
                           return { icon: "fa-times-circle g-state-text g-state-important", tooltip: data.problemInfo }
                       } else if (data && data.sifrovano === 1) {
                           return { icon: "gi-lock g-state-text g-state-important", tooltip: "jres:31950325" } //RC 31950325 : Šifrovaný soubor
                       } else {
                           return { icon: Gordic.Utils.File.getFileTypeIconClass("" + data.typSouboru || " "), tooltip: data.typSouboru }; // TODO;
                       }
                        //GIconDefinition l_oIkona = GPodClientCommon.GetGIconDefinitionOfRegistredFile(row);
                        //if (row.Table.Columns.Contains("sifrovano") && row["sifrovano"].ToString() == "1") l_oIkona = GPodClientCommon.GetGIconDefinitionSifrovano();
                        //return new GImageColumnInfo(GPodCommon.GetIconResources(l_oIkona.ikona), l_oIkona.tooltip);
                    }
               });


            if (gridDto.TypZobrazeni == Interface.TypZobrazeniSouboruElPodaniVTabulce.prehledovySInformacemiOPodpisechARazitcich) {
                definiceFormu
                    .addHtmlColumn({
                        name: "typPodepsaniIcon",
                        caption: "jres:31950200", //RC 31950200 : Příznak el. podpisu a čas. razítka
                        customClass: "center",
                        //width: 50,
                        //fixedWidth: true,
                        cellTemplate: function (data) {
                            var ico: IconTemplate = {};
                            if (data.typPodepsaniIcon && data.typPodepsaniIcon.Ikona) {
                                ico = that.vypocetIkonkyPodpisy(data.typPodepsaniIcon.Ikona, data.typPodepsaniIcon.Tooltip);
                                if (ico && ico.icon) {
                                    var prvek = $("<a>").glink({
                                        params: {
                                            action: new GAction({
                                                name: "actOvereniZGridu",
                                                icon: ico.icon,
                                                //tooltip: ico.tooltip,
                                                customClass: "g-link--no-underline g-state-text",
                                                run: function (event, obj) {
                                                    event.preventDefault();
                                                    var jmenoSouboru = data.jmenoSouboru
                                                    if (jmenoSouboru) {
                                                        that.OtevriOknosVysledkyOvereniZGridu(jmenoSouboru);
                                                    }
                                                }
                                            })
                                        }
                                    });
                                    return prvek.prop('title', ico.tooltip);
                                }
                            }
                            return null;

                        }
                    })
                    .addHtmlColumn({
                        name: "podepsaniInfoIcon",
                        caption: "jres:31950201", //RC 31950201 : Výsledek ověření
                        customClass: "center",
                        //width: 50,
                        //fixedWidth: true,
                        cellTemplate: function (data) {
                            var ico: IconTemplate = {};
                            if (data.podepsaniInfoIcon && data.podepsaniInfoIcon.Ikona) {
                                ico = that.vypocetIkonkyOvereniPodpisu(data.podepsaniInfoIcon.Ikona, data.podepsaniInfoIcon.Tooltip);
                                if (ico && ico.icon) {
                                    var prvek = $("<a>").glink({
                                        params: {
                                            action: new GAction({
                                                name: "actOvereniZGridu",
                                                icon: ico.icon,
                                                //tooltip: ico.tooltip, //RC 31950201 : Výsledek ověření
                                                customClass: "g-link--no-underline g-state-text",
                                                run: function (event,obj) {
                                                    event.preventDefault();
                                                    var jmenoSouboru = data.jmenoSouboru
                                                    if (jmenoSouboru) {
                                                        that.OtevriOknosVysledkyOvereniZGridu(jmenoSouboru);
                                                    }
                                                }
                                            })
                                        }
                                    });
                                    return prvek.prop('title', ico.tooltip);
                                }
                            }
                            return null;
                            
                        }
                    })
            }
            return definiceFormu;
        }

        private createGridVlastnosti(dto: Gordic.Pod.WebControls.GKrok5ElEvidenceDto, contentDiv: JQuery<HTMLElement>) {

            var columns = this.definiceColumnsDoGriduVlastnosti();
            //gridDto.Label label gridu // TODO zatím nevím kam ho prásknout
            this.$GridVlastnosti = $("<div>").appendTo(contentDiv).height(200)
                .ggrid({
                    name: "GridElPodaniVlastnosti",
                    data: new Gordic.Data.View(dto.FormularVlastnosti),
                    renderMode: "auto", // auto, all-at-once, paged-sync, paged-async
                    columnMode: "fit",  // fit, full
                    //rowsClass: function (row, trueColumns, rowIndex) {
                    //    if (row.data.ixs_esu === row.data.ixs_eko) {
                    //        return "bold";
                    //    }
                    //},
                    //  navigationMode: "row", // row, cell
                    
                    // multi: true,

                    // scrollHelperTemplate: "{typ_adr_txt}-{esu_txt}",  // "{ixs_esu} - {nazev}",
                    // searchColumns: ["esu_txt"],
                    columns: columns
                });
        }

        private definiceColumnsDoGriduVlastnosti(): Gordic.Data.GridFormat {

            var definiceFormu = new Gordic.Data.GridFormat()
                .addTextColumn({
                    name: "jmenoVlastnosti",
                    caption: "jres:31950202" //RC 31950202 : Vlastnost
                })
                .addTextColumn({
                    name: "jmenoFormPolozky",
                    caption: "jres:31950203" //RC 31950203 : Název formulářové položky
                })
                .addTextColumn({
                    name: "hodnota",
                    caption: "jres:31950204" //RC 31950204 : Hodnota
                });
            return definiceFormu;
        }

        private vypocetIkonkyPodpisy(txtIco: string, tooltipIco: string): IconTemplate {

            let ico: IconTemplate = {};
            switch (txtIco) {
                case "Gin/e_podpis":
                    ico.icon = "gi-signel g-state-text " + Gin.Globals.Enums.ColorStateClass.important;
                    ico.tooltip = tooltipIco; //RC 23820315 :  Elektronický podpis
                    break;
                case "Gin/casove_razitko":
                    ico.icon = "gi-stamp g-state-text " + Gin.Globals.Enums.ColorStateClass.important;
                    ico.tooltip = tooltipIco; //RC 23820158 : Časové razítko
                    break;
                case "Gin/e_podpis_s_casovym_razitkem":
                    ico.icon = "gi-signtime g-state-text " + Gin.Globals.Enums.ColorStateClass.important;
                    ico.tooltip = tooltipIco; //RC 23820316 : Elektronický podpis a časové razítko
                    break;
                default:
                    return null;
            }
            return ico;
        }


        private vypocetIkonkyOvereniPodpisu(txtIco: string, tooltipIco: string): IconTemplate {

            let ico: IconTemplate = {};
            switch (txtIco) {
                case "Gin/stav_overeni_pozitivni":
                    ico.icon = "gi-tick g-state-text " + Gin.Globals.Enums.ColorStateClass.success;
                    ico.tooltip = tooltipIco; //RC 23820315 :  Elektronický podpis
                    break;
                case "Gin/stav_overeni_negativni":
                    ico.icon = "fa-exclamation-triangle g-state-text " + Gin.Globals.Enums.ColorStateClass.important;
                    ico.tooltip = tooltipIco; //RC 23820158 : Časové razítko
                    break;
                case "Gin/stav_provedeno_s_varovanim":
                    ico.icon = "fa-exclamation-triangle g-state-text " + Gin.Globals.Enums.ColorStateClass.warning;
                    ico.tooltip = tooltipIco; //RC 23820316 : Elektronický podpis a časové razítko
                    break;
                case "Gin/stav_neprovedeno":
                    ico.icon = "gi-window-close g-state-text " + Gin.Globals.Enums.ColorStateClass.important;
                    ico.tooltip = tooltipIco; //RC 23820316 : Elektronický podpis a časové razítko
                    break;
                default:
                    return null;
            }
            return ico;
        }

        //#endregion

        //#region odeslat potvrzeni

        /**
         * funkce pro odeslání potvrzení
         */
        private OdeslatPotvrzeni(): void {
            const that: GEvidenceElPodaniDlg = this;
            this.saveModelFromKork6();
            var VytvoritSouborPodaniDto: GEvidenceElPodaniVytvoritSouborPodaniDto = {};
            if (!this.Krok6VysledekFormu.NoCbx && (this.Krok6VysledekFormu.EmailCbx || this.Krok6VysledekFormu.DSCbx || this.Krok6VysledekFormu.PisCbx)) {
                VytvoritSouborPodaniDto.TextPotvrz = this.Krok6VysledekFormu.TextPotvrz;
                VytvoritSouborPodaniDto.IsPotvrzSigned = this.IsPotvrzSigned;
                VytvoritSouborPodaniDto.EmailCbx = this.Krok6VysledekFormu.EmailCbx;
                VytvoritSouborPodaniDto.EmailSignCbx = this.Krok6VysledekFormu.EmailSignCbx;
                VytvoritSouborPodaniDto.IxsDpo = this.ixsDpo;
                
                
                this.beginOperation();
                Gordic.Pod.Utils.VytvorSouborPotvrzeni(this, VytvoritSouborPodaniDto)
                    .done(function (retVal) {
                        if (retVal.LzeVolatOeslatPozvrzeni) {
                            that.OdeslatPozvrzeni(retVal);
                        } 
                        // opt.PodepsatSouborPotvrzeni = retVal
                    })
                    .always(function () {
                        that.endOperation();
                    });
            } else {
                that.OdeslatPozvrzeni(VytvoritSouborPodaniDto); //předam jen prázdné dto
            }
        }



        /**
         * call odeslání potvrzení
         * 
         * @param {GEvidenceElPodaniVytvoritSouborPodaniDto} SouborPodaniDto
         */
        private OdeslatPozvrzeni(SouborPodaniDto: GEvidenceElPodaniVytvoritSouborPodaniDto): void {
            const that: GEvidenceElPodaniDlg = this;
            var opt: GEvidenceElPodaniOdeslatPotvrzeniInputDto = {};
            opt.NoCbx = this.Krok6VysledekFormu.NoCbx;
            opt.DSCbx = this.Krok6VysledekFormu.DSCbx;
            opt.EmailCbx = this.Krok6VysledekFormu.EmailCbx;
            opt.PisCbx = this.Krok6VysledekFormu.PisCbx;
            opt.OdpEmail = this.Krok6VysledekFormu.OdpEmail;
            opt.OdesIDDS = this.Krok6VysledekFormu.OdesIDDS;
            opt.DSOdDropDown = (this.Krok6VysledekFormu.DSOdDropDownField && this.Krok6VysledekFormu.DSOdDropDownField.mailbox) ? this.Krok6VysledekFormu.DSOdDropDownField.mailbox : null;
            opt.IxsEsu = this.Krok6VysledekFormu.OdesIxs;
            opt.PorZast = this.Krok6VysledekFormu.OdesZastPor;
            opt.LicZast = this.Krok6VysledekFormu.OdesZastLic;
            opt.TextPotvrz = this.Krok6VysledekFormu.TextPotvrz;
            opt.EmailSignCbx = this.Krok6VysledekFormu.EmailSignCbx;
            opt.ZpusDor = this.VysledekSpustitPodaniDto.ZpusDor;
            opt.PodpisMailu = SouborPodaniDto.PodpisMailu;
            opt.IsPotvrzSignedFinal = SouborPodaniDto.IsPotvrzSignedFinal;
            this.call<Gordic.Pod.WebControls.GEvidenceElPodaniOdeslatPotvrzeniDto>("OdeslatPotvrzeniSTestem", { inputDto: opt }, null/*, { progressState: { text: "jres:31950221" } }*/) //RC 31950221 : Probíhá rozbor el. podání

                .done(function (retVal) {
                    if (retVal) {
                        that.krok6_callOdeslatPozvrzeniDone(retVal);
                    }
                })
                .always(function (val1, val2, val3) {
                    var file = new GFile();
                    if (SouborPodaniDto.ObsahSouboruGUID != null && SouborPodaniDto.ObsahSouboruGUID !== "") {
                        file.removeFile(SouborPodaniDto.ObsahSouboruGUID);
                    } if (SouborPodaniDto.ZpravaPotvrzeniGUID != null && SouborPodaniDto.ZpravaPotvrzeniGUID !== "") {
                        file.removeFile(SouborPodaniDto.ZpravaPotvrzeniGUID);
                    }

                });
        }

        /**
         * zpracování callu potvrzení
         * 
         * @param {Gordic.Pod.WebControls.GEvidenceElPodaniOdeslatPotvrzeniDto} dto
         */
        private krok6_callOdeslatPozvrzeniDone(dto: Gordic.Pod.WebControls.GEvidenceElPodaniOdeslatPotvrzeniDto) {
            const that: GEvidenceElPodaniDlg = this;
            this.Krok6VysledekOdeslatPozvrzeni = dto;
            this.zkontrolujHlasku(dto.Hlasky.Hlaska, "Informace").done(function () {
                that.zkontrolujHlasku(dto.Hlasky.Hlaska2, "Informace").done(function () { 
                    that.zkontrolujHlasku(dto.Hlasky.Hlaska3, "Informace").done(function () {
                        //vykonyKod
                        if (dto.PotvrzeniOdeslano) {
                            that.notification("showToast", { icon: "fa-check", content: "jres:31950320", state: "success" }, {delay:6}); //RC 31950320 : Bylo vygenerováno potvrzení pro vybraný externí subjekt.
                        }
                        if (that.testIfCloseForm()) { return; } // pokud byl nastaven příznak na zavření někde.
                        var parentcontent = that.parentContent;
                        that.ZavreniBezOtazky = true;
                        that.tryClose(); // možná that.tryCloseOdemkni();
                        if (dto.OtevriDetailZasilky) {
                            that.otevriDetailZasilky(dto.Sxs, parentcontent);
                        }
                    });
                });
            });

        }

        /**
         * funkce pro otevřeníé detailui zásily
         * 
         * @param {string} sxs
         */
        private otevriDetailZasilky(sxs: string, parentContent: GContent) {
            var opt: Gordic.Wfl.WebClient.GDetailZasilkyDlgInputParams = { Sxs: sxs };
            Gordic.Wfl.Dialogs.GDetailZasilkyDlg(parentContent, opt, Gordic.Global.Enums.ModOtevreni.navigate);
        }



        //#endregion


        //#region hlasky a dotazy

        private zkontrolujHlasku(hlaska:string,nadpis:string): JQuery.Promise<void> {
            let promis = $.Deferred<void>();
            if (hlaska) {
                this.dialogs.alert(nadpis, hlaska).on("closed", function (ev) {
                    promis.resolve();
                })
            } else {
                promis.resolve();
            }
            return promis.promise();
        }

        private zkontrolujInitHlasku(NactiDto: Gordic.Pod.WebControls.GEvidenceElPodaniNactiDataDto, hodnota?: string): JQuery.Promise<void> {
            let promis = $.Deferred<void>();
            if (hodnota) {
                this.dialogs.alert("jres:31950144", hodnota).on("closed", function (ev) { //RC 31950144 : Upozornění
                    promis.resolve();
                })
            } else {
                promis.resolve();
            }
            return promis.promise();
        }

        private zkontrolujInitDotaz(NactiDto: Gordic.Pod.WebControls.GEvidenceElPodaniNactiDataDto): JQuery.Promise<void> {
            let promis = $.Deferred<void>();
            if (NactiDto.UkazDotaz && NactiDto.DotazTxt && !NactiDto.JednaSeOOdpoved) {
                this.dialogs.confirm("jres:23900067", NactiDto.DotazTxt).on("closed", function (ev, retVal) { //RC 23900067 : Dotaz
                    if (retVal === "yes") {
                        NactiDto.DotazPotvrzen = true;
                    } else {
                        NactiDto.CloseForm = true;
                    }
                    promis.resolve();
                })
            } else {
                promis.resolve();
            }
            return promis.promise();
        }

        // krok1
        private zkontrolujKrok1DotazOdmitnuti(krok1Dto: Gordic.Pod.WebControls.GKrok1ElEvidenceDto): JQuery.Promise<void> {
            const that: GEvidenceElPodaniDlg = this;
            let promis = $.Deferred<void>(); 
            
            if (krok1Dto.QuestionDto.OdmitnoutPodani) {
                this.dialogs.confirm("jres:23900067", krok1Dto.QuestionDto.OdmitnoutPodaniTxt).on("closed", function (ev, retVal) { //RC 23900067 : Dotaz
                    if (retVal === "yes") {
                        that.odmitnoutNecitelne(true);
                        // TODO     Odmitnout
                        promis.reject();
                    } else {
                         //Neodmítnout
                        that.tryCloseOdemkni();
                        promis.reject();
                    }
                })
            } else {
                promis.resolve();
            }
            return promis.promise();
        }

        private zkontrolujKrok1DotazPostoupeni(krok1Dto: Gordic.Pod.WebControls.GKrok1ElEvidenceDto): JQuery.Promise<void> {
            let promis = $.Deferred<void>();
            if (krok1Dto.QuestionDto.Postoupeni) {
                this.dialogs.confirm("jres:23900067", krok1Dto.QuestionDto.PostoupeniTxt).on("closed", function (ev, retVal) { //RC 23900067 : Dotaz
                    if (retVal === "yes") {
                        krok1Dto.IsPostoupeni = true;
                    } else {
                        //Nepostoupeni
                    }
                    promis.resolve();
                })
            } else {
                promis.resolve();
            }
            return promis.promise();
        }

        //#endregion

        //#region akce menu

        /**
         * Vytvoří menu.
         *
         * @author  dsebesta
         * @date    01.09.2017
         */
        private _createMenu(): void {
            const that: GEvidenceElPodaniDlg = this;

            // Horní menu.

            const menuBarPole: MenuParams[] = [];
            menuBarPole.push({
                action: that.actions.add(new GAction({
                    name: "actTestZavrit",
                    caption: "jres:31950002", //RC 31950002 : Zavřít
                    tooltip: "jres:31950002", //RC 31950002 : Zavřít
                    run: function () {
                        that.tryCloseOdemkni();
                    }
                })),
                favorite: true
            });
            menuBarPole.push({
                action: that.actions.add(new GAction({
                    name: "actZobrazZpravu",
                    enabled: false,
                    caption: "jres:31950205", //RC 31950205 : Zobrazit
                    tooltip: "jres:31950206", //RC 31950206 : Zobrazit Zpravu
                    run: function () {
                        that.zobrazitZpravuEML();
                    }
                })),
                favorite: true
            });
            menuBarPole.push({
                action: that.actions.add(new GAction({
                    name: "actInfoOAntiviru",
                    enabled: false,
                    //visible: false,
                    caption: "jres:31950207", //RC 31950207 : Info o Antiviru
                    tooltip: "jres:31950207", //RC 31950207 : Info o Antiviru
                    run: function () {
                        that.infoOAntiviru();
                    }
                })),
                favorite: true
            });
            menuBarPole.push({
                action: that.actions.add(new GAction({
                    name: "actRychlaOdpoved",
                    visible: false,
                    caption: "jres:31950032", //RC 31950032 : E-mail
                    tooltip: "jres:31950032", //RC 31950032 : E-mail
                    run: function () {
                        that.rychlaOdpoved();
                    }
                })),
                favorite: true
            });
            menuBarPole.push({
                action: that.actions.add(new GAction({
                    name: "actOdmitnoutZavirovano",
                    caption: "jres:31950015", //RC 31950015 : Zavirováno
                    tooltip: "jres:31950208", //RC 31950208 : Odmítnout z důvodu zavirování
                    run: function () {
                        that.odmitnoutZavirovano();
                    }
                })),
                favorite: true
            });
            menuBarPole.push({
                action: that.actions.add(new GAction({
                    name: "actOdmitnoutNesplnujeStandard",
                    caption: "jres:31950209", //RC 31950209 : Nestandardní
                    tooltip: "jres:31950210", //RC 31950210 : Odmítnout nesplňuje standard
                    run: function () {
                        that.odmitnoutNesplnujeStandard();
                    }
                })),
                favorite: true
            });
            menuBarPole.push({
                action: that.actions.add(new GAction({
                    name: "actOdmitnoutNecitelne",
                    caption: "jres:31950211", //RC 31950211 : Nečitelné
                    tooltip: "jres:31950212", //RC 31950212 : Odmítnout nečitelné
                    run: function () {
                        that.odmitnoutNecitelne(false);
                    }
                })),
                favorite: true
            });
            menuBarPole.push({
                action: that.actions.add(new GAction({
                    name: "actRozeberMailVMailu",
                    visible: false,
                    caption: "jres:31950213", //RC 31950213 : Rozeber
                    tooltip: "jres:31950214", //RC 31950214 : Rozeber mail v příloze
                    run: function () {
                        that.rozeberMailVMailu();
                    }
                })),
                favorite: true
            });
            menuBarPole.push({
                action: that.actions.add(GAction.createPrintAction({
                    name: "actTiskPruvodky",
                    caption: "jres:31950215", //RC 31950215 : Tisk průvodky
                    tooltip: "jres:31950215", //RC 31950215 : Tisk průvodky
                    tema: "pod_ptm_pruelpo",    //nazev tematu
                    visible:false,
                    reportStarting: function (rep) {
                        rep.params.X0000 = that.X0000;
                        rep.params.X0001 = that.X0001;
                        rep.params.X0002 = that.X0002;
                    }
                })),
                favorite: true
            });
            menuBarPole.push({
                action: that.actions.add(new GAction({
                    name: "actKontrolaNearchiv",
                    //visible: false,
                    caption: "jres:31950321", //RC 31950321 : Kontrola formátů
                    tooltip: "jres:31950322", //RC 31950322 : Kontrola formátů
                    run: function () {
                        that.kontrolaNearchivnihoFormatu();
                    }
                })),
                favorite: true
            });
            that.menuBar(that.actions.createBar(menuBarPole));

            // Dolní menu.
            const commandBarPole: MenuParams[] = [];
            commandBarPole.push({
                action: that.actions.add(new GAction({
                    name: "actClose",
                    caption: "jres:31950002", //RC 31950002 : Zavřít
                    tooltip: "jres:31950002", //RC 31950002 : Zavřít
                    run: function () {
                        that.tryCloseOdemkni();
                    }
                })),
                favorite: true
            });
            that.commandBar(that.actions.createBar(commandBarPole));
            //pridání akcí pro krok 3            
        }

        private setGridData(gridDto: GElEvidenceGridDto): void {

            this.PoleGridu = gridDto.Data;
            this.OrigEml = gridDto.OrigEml;
            this.setOrigEml();

            if (this.$Grid && this.$Grid.hasClass("ggrid")) {

                //JS 26.02. 2023 uprava                 
                //var gridackeView: Data.View<Pod.Interface.GElPodaniPrilohyStrukturovaneDto> = this.$Grid.ggrid<Pod.Interface.GElPodaniPrilohyStrukturovaneDto>("getView"); 
                var gridackeView: Data.View<Pod.Interface.GElPodaniPrilohyStrukturovaneDto> = this.$Grid.ggrid<Pod.Interface.GElPodaniPrilohyStrukturovaneDto>("getView"); 
                gridackeView.updateData(gridDto.Data, "set");
            }
        }


        // novy Postup vystaveni menu

        private getMenuForRow(row: Pod.Interface.GElPodaniPrilohyStrukturovaneDto): MenuParams[]  {
            var CeleMenu: MenuParams[] = [];
       
           
            //if (m_IsMailVMailu) {
            //    var l_oItem = new GToolStripMenuItem()  { Action = ActionRozeberMailVMailu };
            //    l_list.Add(l_oItem);
            //}
            var zpracovatJakoPrilohu = this.GetZpracovarJakoPrilohu(row);

            var origAkce = this.GetOriginalItem(row);
            if (origAkce && zpracovatJakoPrilohu == null) { CeleMenu.push(origAkce); }

            //var vyraditAkce = this.GetVyraditPrilohuItem(row);
            //if (vyraditAkce && zpracovatJakoPrilohu == null) { CeleMenu.push(vyraditAkce); }

            var prilohyAkce = this.GetPrilohyItem(row);
            if (prilohyAkce && zpracovatJakoPrilohu == null) { CeleMenu.push(prilohyAkce); }

            var podpisyAkce = this.GetElPodpisyItem(row);
            if (podpisyAkce && zpracovatJakoPrilohu == null) { CeleMenu.push(podpisyAkce); }

            var razitkaAkce = this.GetCasRazitka(row);
            if (razitkaAkce && zpracovatJakoPrilohu == null) { CeleMenu.push(razitkaAkce); }

            
            if (zpracovatJakoPrilohu) { CeleMenu.push(zpracovatJakoPrilohu); }

            if (this.MoznostEditovatNazevPrilohyElPodani && zpracovatJakoPrilohu == null) {
                var prejmenovatPrlohu = this.GetPrejmenovatPrilohuAction(row);
                if (prejmenovatPrlohu) { CeleMenu.push(prejmenovatPrlohu); }
            } 
            //if (GPodClientCommon.MoznostOznacitJakoSifrovane()) l_list.Add(GetOznacitJakoSifrovaneItem(l_sJmenoSouboru, m_oCurrentRow));



            return [{ type: "static", caption:"Akce", children: CeleMenu }] ;
        }     

        //vystvoří akci pro nastavení jako original
        private GetOriginalItem(row: Pod.Interface.GElPodaniPrilohyStrukturovaneDto): MenuParams {
            const that: GEvidenceElPodaniDlg = this;

            if (row.zarazenJako !== Interface.TypZarazeniElSouboru.original) {
                 var action = new GAction({
                    name: "actSetFileJakoOriginal",
                    caption: "jres:31950216", //RC 31950216 : Je originál
                    tooltip: "jres:31950216", //RC 31950216 : Je originál
                    icon: Gordic.Pod.GPodFunction.GetGIconDefinitionTypZarazeniElSouboru(Interface.TypZarazeniElSouboru.original).icon,
                    run: function () {
                        that.setJakoOriginal(row.jmenoSouboru);
                    }
                });
                return { action: action };

            }
            return null;
        }

        private GetVyraditPrilohuItem(row: Pod.Interface.GElPodaniPrilohyStrukturovaneDto): MenuParams {
            const that: GEvidenceElPodaniDlg = this;

            if (row.zarazenJako !== Interface.TypZarazeniElSouboru.original) {
                var action = new GAction({
                    name: "actVyraditPrilohu",
                    caption: "Vyřadit přílohu z el. podání", 
                    tooltip: "Vyřadit přílohu z el. podání", 
                    icon: "gi-paper_elobraz",
                    run: function () {
                        that.vyraditPrilohu(row.jmenoSouboru);
                    }
                });
                return { action: action };

            }
            return null;
        }


        //vytvori strom menu pro nastaveni příloh
        private GetPrilohyItem(row: Pod.Interface.GElPodaniPrilohyStrukturovaneDto): MenuParams {
            const that: GEvidenceElPodaniDlg = this;
            
            var jmenoSouboru = row.jmenoSouboru.trim(); // jmeno oznaceneho souboru
            var radky = this.PoleGridu;

            var poleNabidky: Nabidka[] = [];
            for (var i = 0; i < radky.length; i++) {
                 // tady využívají (DataTable)UserProcess.Context.GetParam("ElPodani", "DataTableOriginaly"); // podle meho je to vyfiltrovana normal
                if (((radky[i].zarazenJako) === Interface.TypZarazeniElSouboru.original)&& 
                    (radky[i]["jmenoSouboru"].trim() != that.OriginalJeZpravaSymbol && radky[i]["jmenoSouboru"].trim() != jmenoSouboru))
                { 
                    let temp: Nabidka = {};
                    temp.nazev = radky[i]["jmenoSouboru"].trim();
                    poleNabidky.push(temp);
                }
            }

            if (poleNabidky.length === 0) { // jedna se o originál
                let action = new GAction({
                    name: "actOznacJakoPrilohu",
                    caption: "jres:31950217", //RC 31950217 : Je příloha
                    tooltip: "jres:31950217", //RC 31950217 : Je příloha
                    icon: Gordic.Pod.GPodFunction.GetGIconDefinitionTypZarazeniElSouboru(Interface.TypZarazeniElSouboru.priloha).icon,
                    run: function () {
                        that.callSetFileJakoPriloha(jmenoSouboru,null);
                    }
                });
                return { action: action };
            } else {   // vybere čeho je to příloha
                var MenuNabidky: MenuParams[] = [];
                for (var j = 0; j < poleNabidky.length; j++) {
                    let action = new GAction({
                        name: "actPriradiJakoPrilohu",
                        caption: poleNabidky[j].nazev,
                        tooltip: poleNabidky[j].nazev,
                        param: poleNabidky[j].nazev,
                        icon: Gordic.Pod.GPodFunction.GetGIconDefinitionTypZarazeniElSouboru(Interface.TypZarazeniElSouboru.original).icon,
                        run: function () {
                            that.callSetFileJakoPriloha(jmenoSouboru,this.param);
                        }
                    });
                    MenuNabidky.push({ action: action });
                }

                return {
                    type: "static",
                    caption: "jres:31950217", //RC 31950217 : Je příloha
                    tooltip: "jres:31950217", //RC 31950217 : Je příloha
                    children: MenuNabidky,
                    icon: Gordic.Pod.GPodFunction.GetGIconDefinitionTypZarazeniElSouboru(Interface.TypZarazeniElSouboru.priloha).icon,
                };
            }
        }

        //vytvori strom menu pro nastaveni podpisů
        private GetElPodpisyItem(row: Pod.Interface.GElPodaniPrilohyStrukturovaneDto): MenuParams {
            const that: GEvidenceElPodaniDlg = this;

            var jmenoSouboru = row.jmenoSouboru.trim(); // jmeno oznaceneho souboru
            var radky = this.PoleGridu;

            var poleNabidky: Nabidka[] = [];
            for (var i = 0; i < radky.length; i++) {
                // tady využívají (DataTable)UserProcess.Context.GetParam("ElPodani", "DataTableOriginaly"); // podle meho je to vyfiltrovana normal
                var typ = radky[i].zarazenJako; 
                if ((typ === Interface.TypZarazeniElSouboru.original) || (typ === Interface.TypZarazeniElSouboru.priloha) && (radky[i]["jmenoSouboru"].trim() != jmenoSouboru))
                {
                    let temp: Nabidka = {};
                    temp.nazev = radky[i]["jmenoSouboru"].trim();
                    temp.icon =
                        (typ === Interface.TypZarazeniElSouboru.original)
                        ? Gordic.Pod.GPodFunction.GetGIconDefinitionTypZarazeniElSouboru(Interface.TypZarazeniElSouboru.original).icon
                        : Gordic.Pod.GPodFunction.GetGIconDefinitionTypZarazeniElSouboru(Interface.TypZarazeniElSouboru.priloha).icon
                    poleNabidky.push(temp);
                }
            }

            if (poleNabidky.length === 0) { // jedna se o originál
                //let action = new GAction({
                //    name: "actOznacJakoElPodpis",
                //    caption: "Je el.podpis",
                //    tooltip: "Je el.podpis",
                //    icon: Gordic.Pod.GPodFunction.GetGIconDefinitionTypZarazeniElSouboru(Interface.TypZarazeniElSouboru.elPodpis).icon,
                //    run: function () {
                //        that.callSetFileJakoPriloha(jmenoSouboru, null);
                //    }
                //});
                //return { action: action };
                return null;
            } else {   // vybere čeho je to příloha
                var MenuNabidky: MenuParams[] = [];
                for (var j = 0; j < poleNabidky.length; j++) {
                    let action = new GAction({
                        name: "actOznacJakoElPodpis",
                        caption: poleNabidky[j].nazev,
                        tooltip: poleNabidky[j].nazev,
                        param: poleNabidky[j].nazev,
                        icon: poleNabidky[j].icon,
                        run: function () {
                            that.callSetFileJakoElPodpis(jmenoSouboru, this.param);
                        }
                    });
                    MenuNabidky.push({ action: action });
                }

                return {
                    type: "static",
                    caption: "jres:31950218", //RC 31950218 : Je el.podpis
                    tooltip: "jres:31950218", //RC 31950218 : Je el.podpis
                    children: MenuNabidky,
                    icon: Gordic.Pod.GPodFunction.GetGIconDefinitionTypZarazeniElSouboru(Interface.TypZarazeniElSouboru.elPodpis).icon,
                };
            }
        }

        //vytvori strom menu pro nastaveni podpisů
        private GetCasRazitka(row: Pod.Interface.GElPodaniPrilohyStrukturovaneDto): MenuParams {
            const that: GEvidenceElPodaniDlg = this;

            var jmenoSouboru = row.jmenoSouboru.trim(); // jmeno oznaceneho souboru
            var radky = this.PoleGridu;

            var poleNabidky: Nabidka[] = [];
            for (var i = 0; i < radky.length; i++) {
                // tady využívají (DataTable)UserProcess.Context.GetParam("ElPodani", "DataTableOriginaly"); // podle meho je to vyfiltrovana normal
                var typ = radky[i].zarazenJako;
                if (((typ === Interface.TypZarazeniElSouboru.original) || (typ === Interface.TypZarazeniElSouboru.priloha))
                    && (radky[i]["jmenoSouboru"].trim() != jmenoSouboru)) {
                    let temp: Nabidka = {};
                    temp.nazev = radky[i]["jmenoSouboru"].trim();
                    temp.icon =
                        (typ === Interface.TypZarazeniElSouboru.original)
                            ? Gordic.Pod.GPodFunction.GetGIconDefinitionTypZarazeniElSouboru(Interface.TypZarazeniElSouboru.original).icon
                            : Gordic.Pod.GPodFunction.GetGIconDefinitionTypZarazeniElSouboru(Interface.TypZarazeniElSouboru.priloha).icon
                    poleNabidky.push(temp);
                }
            }

            if (poleNabidky.length === 0) { // jedna se o originál
                //let action = new GAction({
                //    name: "actOznacJakoElPodpis",
                //    caption: "Je el.podpis",
                //    tooltip: "Je el.podpis",
                //    icon: Gordic.Pod.GPodFunction.GetGIconDefinitionTypZarazeniElSouboru(Interface.TypZarazeniElSouboru.elPodpis).icon,
                //    run: function () {
                //        that.callSetFileJakoPriloha(jmenoSouboru, null);
                //    }
                //});
                //return { action: action };
                return null;
            } else {   // vybere čeho je to příloha
                var MenuNabidky: MenuParams[] = [];
                for (var j = 0; j < poleNabidky.length; j++) {
                    let action = new GAction({
                        name: "actOznacJakoElPodpis",
                        caption: poleNabidky[j].nazev,
                        tooltip: poleNabidky[j].nazev,
                        param: poleNabidky[j].nazev,
                        icon: poleNabidky[j].icon,
                        run: function () {
                            that.callSetFileJakoCasRazitko(jmenoSouboru, this.param);
                        }
                    });
                    MenuNabidky.push({ action: action });
                }

                return {
                    type: "static",
                    caption: "jres:31950172", //RC 31950172 : Je časové razítko
                    tooltip: "jres:31950172", //RC 31950172 : Je časové razítko
                    children: MenuNabidky,
                    icon: Gordic.Pod.GPodFunction.GetGIconDefinitionTypZarazeniElSouboru(Interface.TypZarazeniElSouboru.casoveRazitko).icon,
                };
            }
        }

        //vystvoří akci pro nastavení jako original
        private GetZpracovarJakoPrilohu(row: Pod.Interface.GElPodaniPrilohyStrukturovaneDto): MenuParams {
            const that: GEvidenceElPodaniDlg = this;
            
            if (row.zarazenJako == Interface.TypZarazeniElSouboru.vnorenaPriloha) {
                var action = new GAction({
                    name: "actZpracovatJakoPrilohu",
                    caption: row.zpracovatJakoPrilohu ? "jres:31950329" : "jres:31950327", //RC 31950329 : Zpracovat jako vnořenou přílohu  //RC 31950327 : Zpracovat jako samostatnou přílohu
                    tooltip: row.zpracovatJakoPrilohu ? "jres:31950329" : "jres:31950327", //RC 31950329 : Zpracovat jako vnořenou přílohu  //RC 31950327 : Zpracovat jako samostatnou přílohu
                    icon: Gordic.Pod.GPodFunction.GetGIconZpracovatJakoSamostatnouPrilohu().icon,
                    run: function () {
                        // bool.Parse(m_oCurrentRow["zpracovatJakoPrilohu"].ToString());
                        that.callSetVnorenyFileJakoStandardni(row);
                    }
                });
                return { action: action };

            }
            return null;
        }

        private GetPrejmenovatPrilohuAction(row: Pod.Interface.GElPodaniPrilohyStrukturovaneDto): MenuParams {
            const that: GEvidenceElPodaniDlg = this;

            //if (Gordic.Pod.GPodFunction.GetTypZarazeniElSouboruByPriznak(row.zarazenJako) == Interface.TypZarazeniElSouboru.vnorenaPriloha) {
                var action = new GAction({
                    name: "actPrejmenovatSoubor",
                    caption: "jres:31950358", //RC 31950358 : Přejmenovat soubor
                    tooltip: "jres:31950358", //RC 31950358 : Přejmenovat soubor
                    //icon: Gordic.Pod.GPodFunction.GetGIconZpracovatJakoSamostatnouPrilohu().icon,
                    run: function () {
                        // bool.Parse(m_oCurrentRow["zpracovatJakoPrilohu"].ToString());
                        that.prejmenovatPrilohuRun(row);
                    }
                });
                return { action: action };

            //}
            //return null;
        }



        //------------------------funkce volané z akcí  z menu na řádku
        private vyraditPrilohu(jmenoSouboru:string): void {
            const that: GEvidenceElPodaniDlg = this;
     
            var opt = {
                JmenoSouboru: jmenoSouboru,
                ZpusDor: this.VysledekSpustitPodaniDto.ZpusDor
            }
            this.call<GElEvidenceGridDto>("SetFileJakoOriginal", opt).done(function (retVal) {
                that.OrigEml = false;
                that.setOrigEml();
                that.setGridData(retVal);
            });
            
        }

        private setJakoOriginal(jmenoSouboru: string): void {
            const that: GEvidenceElPodaniDlg = this;

            var opt = {
                JmenoSouboru: jmenoSouboru,
                ZpusDor: this.VysledekSpustitPodaniDto.ZpusDor
            }
            this.call<GElEvidenceGridDto>("SetFileJakoOriginal", opt).done(function (retVal) {
                that.OrigEml = false;
                that.setOrigEml();
                that.setGridData(retVal);
            });

        }

        private callSetFileJakoPriloha(jmenoSouboru: string, jmenoNadrizeneho: string): void {
            const that: GEvidenceElPodaniDlg = this;
            var opt = {
                JmenoSouboru: jmenoSouboru,
                JmenoNadrizeneho: jmenoNadrizeneho,
                ZpusDor: this.VysledekSpustitPodaniDto.ZpusDor
            }
            this.call<GElEvidenceGridDto>("SetFileJakoPriloha", opt).done(function (retVal) {
                that.setGridData(retVal);
            });

        } 

        private callSetFileJakoElPodpis(jmenoSouboru: string, jmenoNadrizeneho: string): void {
            const that: GEvidenceElPodaniDlg = this;
            var opt = {
                JmenoSouboru: jmenoSouboru,
                JmenoNadrizeneho: jmenoNadrizeneho,
                ZpusDor: this.VysledekSpustitPodaniDto.ZpusDor
            }
            this.call<GElEvidenceGridDto>("SetFileJakoElPodpis", opt).done(function (retVal) {
                that.setGridData(retVal);
                that.zkontrolujHlasku(retVal.Hlaska, "jres:31950055"); //RC 31950055 : Pozor
            });

        } 
        private callSetFileJakoCasRazitko(jmenoSouboru: string, jmenoNadrizeneho: string): void {
            const that: GEvidenceElPodaniDlg = this;
            var opt = {
                JmenoSouboru: jmenoSouboru,
                JmenoNadrizeneho: jmenoNadrizeneho,
                ZpusDor: this.VysledekSpustitPodaniDto.ZpusDor
            }
            this.call<GElEvidenceGridDto>("SetFileJakoCasRazitko", opt).done(function (retVal) {
                that.setGridData(retVal);
                that.zkontrolujHlasku(retVal.Hlaska, "jres:31950055"); //RC 31950055 : Pozor
            });

        } 

        private callOrigEmlZmena(origEml: boolean): void {
            const that: GEvidenceElPodaniDlg = this;
            var opt = {
                OrigEml: origEml,
                ZpusDor: this.VysledekSpustitPodaniDto.ZpusDor
            }
            this.call<GElEvidenceGridDto>("OrigEmlZmena", opt).done(function (retVal) {
                that.setGridData(retVal);
                that.zkontrolujHlasku(retVal.Hlaska, "Pozor");
            });
        } 

        private callSetVnorenyFileJakoStandardni(row: Pod.Interface.GElPodaniPrilohyStrukturovaneDto): void {
            const that: GEvidenceElPodaniDlg = this;
            if (row.IDGenerated) {
                var opt = {
                    IDGenerated: row.IDGenerated,
                    ZpusDor: this.VysledekSpustitPodaniDto.ZpusDor
                }

                this.call<GElEvidenceGridDto>("SetVnorenyFileJakoStandardni", opt).done(function (retVal) {
                    that.setGridData(retVal);
                    that.zkontrolujHlasku(retVal.Hlaska, "Pozor");
                });
            } else {
                this.log.trace("El Podani - callSetVnorenyFileJakoStandardni TS , nevyplněn row.IDGenerated");
            }
        }


        private prejmenovatPrilohuRun(row: Pod.Interface.GElPodaniPrilohyStrukturovaneDto): void {
            const that: GEvidenceElPodaniDlg = this;
            
            var l_sJmenoSoubjoru = row.jmenoSouboru;
            this.dialogs.prompt(
                "jres:31950359", //RC 31950359 : Změna názvu
                "jres:31950360", //RC 31950360 : Název souboru
                l_sJmenoSoubjoru ? l_sJmenoSoubjoru.trim() : ""
            )
                .on("closed", function (event, retVal: { text?: string }) {
                    
                    if (retVal?.text) {
                        var opt = {
                            dto: row,
                            noveJmeno: retVal?.text
                        }
                        that.call("PrejmenujPrilohu", opt)
                            .done(function (zmeneno) {
                                if (zmeneno) {
                                    that.resetVsehoOdKroku(2, true);
                                    that.aktivujKrok(2)
                                }


                            });
                    } 
                });
           
        }

        
        //konec noveho Postupu
        private nastavEnableNaAkcichPodleKroku(): void {

            switch (this.aktualniCisloKroku) {
                case 2:
                    break;
                case 3:
                    break;
                case 4:
                    break;
                case 5:
                    break;
                case 6:
                    this.actions["actOdmitnoutZavirovano"].enabled(false);
                    this.actions["actOdmitnoutNesplnujeStandard"].enabled(false);
                    this.actions["actOdmitnoutNecitelne"].enabled(false);
                    
                    break;
                default:
            }
            
            if (this.PouzePrehled) {
                this.actions["actOdmitnoutZavirovano"].enabled(false);
                this.actions["actOdmitnoutNesplnujeStandard"].enabled(false);
                this.actions["actOdmitnoutNecitelne"].enabled(false);
                this.actions["actRozeberMailVMailu"].enabled(false);
            }

        }

        private zobrazitZpravuEML(): void {
            this.log.trace("zobrazitZpravuEML");
            if (this.VysledekSpustitPodaniDto.ZpusDor === Wfl.Interface.TypPrijmuPodani.InterniVypraveni)
            {
                //TODO
                //GWflCommon.OpenDetailZasilky(new GSxs(PodElPodaniProp.WflsinbDtoInst.uidl.Trimmed), Task);
            }
            else { 
                this.zobrazitZpravu(this.VysledekKrok1Call1.CestaKEml,true);
            }
        }

        private stahniSoubor(cestaKsoubru: string, pouzestahnout:boolean): void {
            this.log.trace("stahniSoubor");
            //var cesta = this.VysledekKrok1Call1.SlozkaSouboruPodani.trim() + nazev.trim();
            this.zobrazitZpravu(cestaKsoubru, pouzestahnout);
        }

        private zobrazitZpravu(cesta: string, pouzestahnout: boolean): void {
            var that = this;
            this.log.trace(cesta); 
            var opt = {
                cesta: cesta
            };
            this.call("ZobrazitZpravu", opt)
                .done(function (retVal) {
                    if (retVal) {
                        that.log.trace("Guid:" + retVal); 
                        if (pouzestahnout) {
                            that.stahnoutZpravuFinal(retVal);
                        } else {
                            that.zobrazitZpravuFinalPresDoplnek(retVal);
                        }
                        //
                        
                    }

                });
            //TODO nějaká externí funkce na otevření doumentu   //ZobrazSoubor (basePage.cs)    // GDocumentViewer.ShowDocument(this, l_oUrl);
        }



        private stahnoutZpravuFinal(guid): void {
            var that = this;
            this.beginOperation();
            var file = new GFile();
            var opt = {
                guid: guid
            };
            this.log.trace("stahnoutZpravuFinal guid:" + guid); 
            file.download(opt)
                .then(function () {
                    that.log.trace("Proběhlo stažení souboru."); 
                    that.showFlash("jres:31950249", "success","StazeniSouboru"); //RC 31950249 : Proběhlo stažení souboru.
                    that.endOperation();
                },
                    function () {
                        that.log.trace("Stažení nedopadlo"); 
                        that.endOperation();
                        return;
                    })
                .always(function () {
                    file.removeFile(guid);
                })
                ;
        }

        private zobrazitZpravuFinalPresDoplnek(guid): void {
            var that = this;
            //this.beginOperation();
            var dto = {
                DownloaderType: "Gordic.Wfl.WebClient.WflGuidDownloader",
                AutoDownload: true,
                DisablePluginDownload: false,
                CustomData: {
                    "Guid": guid
                }
            };

            var doc = new GDocument(this);
            this.log.trace("zobrazitZpravuFinalPresDoplnek guid:" + guid);
            doc.downloadDocument(dto)
                .then(function () {
                    that.log.trace("Proběhlo stažení souboru.");
                    //that.showFlash("jres:31950249", "success", "StazeniSouboru"); //RC 31950249 : Proběhlo stažení souboru.
                    //that.endOperation();
                },
                    function () {
                        that.log.trace("Stažení nedopadlo");
                        //that.endOperation();
                        return;
                    })
                .always(function () {
                    var file = new GFile();
                    file.removeFile(guid);
                })
            ;
        }

        private stahniZipPodani(): void {
            var that = this;
           
            this.call("StartExportZip")
                .done(function (retVal) {
                    if (retVal && retVal.FileInfoDto && retVal.FileInfoDto.guid) {
                        that.log.trace("Guid:" + retVal.FileInfoDto.guid);
                        that.stahnoutZpravuFinal(retVal.FileInfoDto.guid);
                    }

                });
        }

        private infoOAntiviru(): void {
            Gordic.Pod.Dialogs.AntivirInfoDlg(this, Global.Enums.ModOtevreni.showModalWindow);
           
        }
        private rychlaOdpoved(): void {
            var that = this;
            this.call("RychlaOdpoved", {})
                .done(function (retVal) {
                    if (retVal) {
                        that.dialogs.messageBox(
                            "jres:31950356", //RC 31950356 : Upozornění
                            "jres:31950357" //RC 31950357 : E-mail byl odeslán.
                        );
                    }
                    else {
                        that.dialogs.warning("jres:31950356" //RC 31950356 : Upozornění
                            , "jres:31950355"); //RC 31950355 : E-mail nebyl odeslán.
                    }
            });

            //TODO
        }
        private odmitnoutZavirovano(): void {
            this.odmitnoutPodani(Interface.DuvodOdmitnutiElPodani.neprosloVirovouKontrolou,false);
        }
        private odmitnoutNesplnujeStandard(): void {
            this.odmitnoutPodani(Interface.DuvodOdmitnutiElPodani.nesplnujeStandard,false);
        }
        private odmitnoutNecitelne(pokudNepotvrdiDotazZavrit:boolean): void {
            this.odmitnoutPodani(Interface.DuvodOdmitnutiElPodani.necitelne, pokudNepotvrdiDotazZavrit);
        }
        private rozeberMailVMailu(): void {
            const that: GEvidenceElPodaniDlg = this;
            var inputDto: Gordic.Pod.WebControls.GEvidenceElPodaniRozeberMailVMailuInputDto = {};

            inputDto.ZpusDor = this.VysledekSpustitPodaniDto.ZpusDor;
            inputDto.FileNameZpravaVeZprave = this.VysledekKrok1Call1.FileNameZpravaVeZprave;
            inputDto.JeAntivir = this.VysledekSpustitPodaniDto.JeAntivir;
            inputDto.NoAntivir = this.VysledekSpustitPodaniDto.NoAntivir;
            inputDto.OrigEml = this.getOrigEml();
            inputDto.StavInb = this.VysledekSpustitPodaniDto.StavInb;

            this.call<Gordic.Pod.WebControls.GEvidenceElPodaniRozeberMailVMailuDto>("RozeberMailVMailu", { inputDto: inputDto}, null/*, { progressState: { text: "jres:31950220" } }*//*, { progressState: "Načítám data" }*/)//RC 31950220 : Načítám data
                .done(function (retVal) { 
                   
                    if (retVal) {
                        that.zkontrolujHlasku(retVal.Hlaska, "jres:31950144").done(function () { //RC 31950144 : Upozornění

                            //sekce GEx 
                            if (retVal.GexNedopadl) {
                                if (retVal.TextOdmitnoutPodani) {
                                    that.dialogs.confirm("jres:31950284", retVal.TextOdmitnoutPodani).on("closed", function (ev, retVal) { //RC 31950284 : Dotaz
                                        if (retVal === "yes") {
                                            that.odmitnoutNecitelne(false);
                                        } else {
                                            if (retVal.GexNedopadlMsgPrazdne) {
                                                that.tryCloseOdemkni();
                                                return;
                                            }
                                        }
                                    })

                                }
                            }
                            if (retVal.DZpoleDto) {
                                that.UpravHodnotyPodleDZPole(retVal.DZpoleDto);
                            }
                            //sekce gex end
                            if (retVal.Krok1Dto && retVal.Krok1Dto.DZPole) {
                                that.UpravHodnotyPodleDZPole(retVal.Krok1Dto.DZPole);
                            }
                            that.ZpracovatJakoMsgInMsg = retVal.ZpracovatJakoMsgInMsg;

                            if (retVal.ZpracovatJakoMsgInMsg) {

                                if (retVal.CisKrok === 0) {
                                    that.aktualniCisloKroku = 0;
                                    that.provedenoKroku = 0;
                                    that.spustitPodaniZnovu();
                                }
                                else if (retVal.CisKrok === 1) {
                                    that.aktualniCisloKroku = 1;
                                    that.provedenoKroku = 1;
                                    that.pokracuj();
                                }

                            }
                        });
                   
                    }
                });
        }



        /// <summary> Odmitnout podani </summary>
        private odmitnoutPodani(duvodOdmitnuti: Interface.DuvodOdmitnutiElPodani, pokudNepotvrdiDotazZavrit: boolean): void {
            const that: GEvidenceElPodaniDlg = this;
            if (!this.PouzePrehled) {
                // získání textového důvodu odmítnutí
                this.dialogs.confirm("jres:31950143", //RC 31950143 : Otázka
                    "jres:31950142").on("closed", function (ev, retVal) { //RC 31950142 : Opravdu chcete odmítnout toto podání?
                        if (retVal === "yes") {
                            that.DuvodOdmitnuti = duvodOdmitnuti;
                            //ZneviditelniPrvky();
                            that.krokx_setniIkonku(5, "krizek");
                            //SetOdmitnutiInfoPanel(duvodOdmitnuti);

                            that.ZobrDetCbxValue = false;
                            that.ZobrDetCbxDisable = false;
                            that.setZobrDetCbx();
                            that.PolePovolenychKroku[5] = true;
                            that.aktivujKrok(6);
                            //RefreshStavu = true;

                            //SetPrvku();
                        } else {
                            if (pokudNepotvrdiDotazZavrit) {
                                that.tryCloseOdemkni();
                            }
                            //Nepostoupeni
                        }
                    });
            }
        }


        private pridatIFRAME(): void {
            const that: GEvidenceElPodaniDlg = this;

            var iframeDiv = $("<div>");// style='position: relative;'
            var options: Gordic.Wfl.WebClient.GEformSKInputOptions = {
                codedHtml: (this as any).codedHtml,
            }
            iframeDiv.appendTo(that.element)
            
            iframeDiv.gcontent([(Gordic.Wfl.WebClient as any).GEformSK, { inputOpt: options }]);
            iframeDiv.gtab({
                title: "jres:31950219", //RC 31950219 : Formulář
                opened: true

            }).on("gtabopen", function () {
                ($.content(iframeDiv) as any).resizeIframe();
            }); //, opened: true
            //iframeDiv.css("height", iframeDiv.find("iframe").outerHeight());
            
        }

        private zmenaStepu(nextStep: number): void {


            if (this.PouzePrehled) {
                return;
            }

            //nextStep = nextStep + 1; // aby se neindexovalo od nuly
            this.resetVsehoOdKroku(nextStep + 1); // posíláme o 2 číslo větší protože se tu motají jmena kroku s indexem v poli a resetuju od následujícího kroku
            switch (nextStep) {
                case 1:
                    this.PolePovolenychKroku[3] = false;
                case 2:
                    this.PolePovolenychKroku[4] = false;
                case 3:
                    this.PolePovolenychKroku[5] = false;
                //case 4:
                //    this.PolePovolenychKroku[5] = false;

                    break;
                default:
            }
        }

        private resetVsehoOdKroku(krokNaKteremZacneReset: number, hardReset?:boolean): void {

            var resetovat = true;
            if (this.provedenoKroku > krokNaKteremZacneReset) {
                this.provedenoKroku = krokNaKteremZacneReset;
            }else if(hardReset){
                resetovat = true;
            }
            else {
                resetovat = false;
            }
            // Pozor switch bez breaku aby to šlo pekne postupně
            switch (krokNaKteremZacneReset) {
                case 0:
                    this.krokx_setniIkonku(1, "nic");
                case 1:
                    this.krokx_setniIkonku(2, "nic");
                case 2:
                    if (resetovat)this.Step2_MaAktualniDataProVykresleni = false;
                    this.krokx_setniIkonku(3, "nic");
                case 3:
                    if (resetovat)this.Step3_MaAktualniDataProVykresleni = false;
                    this.krokx_setniIkonku(4, "nic");
                case 4:
                    if (resetovat)this.Step4_MaAktualniDataProVykresleni = false;
                    this.krokx_setniIkonku(5, "nic");
                case 5:
                    if (resetovat)this.Step5_MaAktualniDataProVykresleni = false;
                    this.krokx_setniIkonku(6, "nic");
                case 6:
                    if (resetovat)this.Step6_MaAktualniDataProVykresleni = false;
                   
                break;
                default:
            }



        }

        private setniHlavniIkonyOvereniPodpisu(ImgPodpisuZpravy: string, ImgPodpisuZpravyTxt: string|undefined, ImgOvereniPodpisu: string, ImgOvereniPodpisuTxt: string|undefined): void {
            var that = this;

            if (ImgPodpisuZpravy && ImgPodpisuZpravy != "" && ImgPodpisuZpravy != "Gin/nic") {
                var text = ImgPodpisuZpravyTxt ? ImgPodpisuZpravyTxt: "" ;
                    
                var giICo = that.vypocetIkonkyPodpisy(ImgPodpisuZpravy, text);
                if (giICo) { 
                    this.setFieldPodpisuZpravy(giICo);
                }
            }

            if (ImgOvereniPodpisu && ImgOvereniPodpisu != "" && ImgOvereniPodpisu != "Gin/nic") {
                var text = ImgOvereniPodpisuTxt ? ImgOvereniPodpisuTxt : "";
                var giICo = that.vypocetIkonkyOvereniPodpisu(ImgOvereniPodpisu, text);
                if (giICo) {
                    this.setFieldImgOvereniPodpisu(giICo);
                }
            }
            

        }

        private setFieldImgOvereniPodpisu(giICo: IconTemplate) {
            var that = this;
            var maxpocetZnaku = 50; //50
            var fieldStavPodpisuZpravy = this.findFields("StavPodpisuZpravy");
            (fieldStavPodpisuZpravy as any).gformsection().show();
            var textDoPolicka = giICo.tooltip ? giICo.tooltip : "";
            if (textDoPolicka && textDoPolicka.length > maxpocetZnaku) {
                textDoPolicka = textDoPolicka.substr(0, maxpocetZnaku) + "...";
            }
            fieldStavPodpisuZpravy.gfield("setValue", textDoPolicka);
            fieldStavPodpisuZpravy.gfield("addState", {
                id: "ImgOvereniPodpisu",     // nepovinný, pouze pokud bude potřeba ikonu adresovat/měnit
                icon: giICo.icon,
                customClass: " fa-2x js-ImgOvereniPodpisu",
                tooltip: giICo.tooltip,
                align: "opposite"
            });
            $(".js-ImgOvereniPodpisu").css("cursor", "pointer").click(function () {
                that.OtevriOknoVysledkuOverenu();
            });
        }

        private setFieldPodpisuZpravy(giICo: IconTemplate) {
            var that = this;
            var maxpocetZnaku = 50; //50
            var fieldPodpisZpravy = this.findFields("PodpisZpravy");
            (fieldPodpisZpravy as any).gformsection().show();
            var textDoPolicka = giICo.tooltip ? giICo.tooltip : "";
            if (textDoPolicka && textDoPolicka.length > maxpocetZnaku) {
                textDoPolicka = textDoPolicka.substr(0, maxpocetZnaku) + "...";
            }
            fieldPodpisZpravy.gfield("setValue", textDoPolicka);
            fieldPodpisZpravy.gfield("addState", {
                id: "ImgPodpisuZpravy",     // nepovinný, pouze pokud bude potřeba ikonu adresovat/měnit
                icon: giICo.icon + " g-state-text " + Gin.Globals.Enums.ColorStateClass.important,
                customClass: " fa-2x js-ImgPodpisuZpravy",
                tooltip: giICo.tooltip,
                align: "opposite"
            });
            $(".js-ImgPodpisuZpravy").css("cursor", "pointer").click(function () {
                that.OtevriOknoVysledkuOverenu();
            });
        }

        public OtevriOknoVysledkuOverenu() {
            this.log.trace("OtevriOknoVysledkuOverenu"); 
            Gordic.Wfl.Dialogs.GOveritPodpisContextDlg(this, {
                ParamGroup: "ElPodani",
                ParamName: "WflPoleOverInfoZpravy",
                Filename: "jres:31950266" //RC 31950266 : Výsledek oveření jednotlivých podpisů souboru
                //Filename: rowData.JmenoSouboru
            }, 
                Gordic.Global.Enums.ModOtevreni.showModalWindow
            );

              //Gordic.Wfl.Dialogs.GOveritPodpisDlg(cnt, { ixp: dto.Ixp, ixb: dto.File!.Ixb, filename: dto.File!.Name } as any, Gordic.Global.Enums.ModOtevreni.showModalWindow);
        }

        public OtevriOknosVysledkyOvereniZGridu(jmenoSouboru: string) {
            var that = this;
            if (jmenoSouboru != null) {
                var opt = {
                    jmenoSouboru: jmenoSouboru
                };
                this.call<Wfl.Interface.GOveritPodpisDto>("OvereniPodpisuFromGrid", opt).done(function (ret) {
                    if (ret) {
                        that.OtevriOknoVysledkuOvereniZGridu(ret);

                    }
                });
            }
        }

        public OtevriOknoVysledkuOvereniZGridu(dto: Wfl.Interface.GOveritPodpisDto ) {
            var that = this;
            Gordic.Wfl.Dialogs.GOveritPodpisDlg(this, {
                dto: dto
            },
                Gordic.Global.Enums.ModOtevreni.showModalWindow
            );

        }

        private SetniHlavniIkonyOvereniPodpisuZKroku5(ImgPodpisuZpravy: string, ImgPodpisuZpravyTxt: string | undefined, ImgOvereniPodpisu: string, ImgOvereniPodpisuTxt: string | undefined) {
            var that = this;
          
            if (ImgPodpisuZpravy && ImgPodpisuZpravy != "" && ImgPodpisuZpravy != "Gin/nic") {
              
                var giICo: IconTemplate = {};
                giICo.icon = ImgPodpisuZpravy;
                giICo.tooltip = ImgPodpisuZpravyTxt;
                if (giICo ) {
                    this.setFieldPodpisuZpravy(giICo);
                }
            }
            //cursor:pointer

            if (ImgOvereniPodpisu && ImgOvereniPodpisu != "" && ImgOvereniPodpisu != "Gin/nic") {
                var giICo: IconTemplate = {};
                giICo.icon = ImgOvereniPodpisu;
                giICo.tooltip = ImgOvereniPodpisuTxt;
                if (giICo) {
                    this.setFieldImgOvereniPodpisu(giICo);
                }
            }
            

        }

        private kontrolaNearchivnihoFormatu() {
            var that = this;
            this.call("KontrolaNearchivnihoFormatu", {})
                .done(function (ret) {
                    if (ret != null && ret.KontrolaOK) {
                        that.dialogs.messageBox(
                            "jres:31950323", //RC 31950323 : Kontrola nearchivního formátu
                            ret.KontrolaTxt
                        );
                    }
                    else {
                        that.dialogs.warning(
                            "jres:31950323", //RC 31950323 : Kontrola nearchivního formátu
                            ret.KontrolaTxt
                        );
                    }
                });
        }

        private restartCacheReadru() {
            var that = this;
            //Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderGinsmbx");
            Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderSslstyp"); // u SK formulářů se vytváří nové dokumenty.
        }

        /*
        private tiskPodacihoRazitka(tiskPodacihoRazitka:boolean): JQuery.Promise<void> {

            let promis = $.Deferred();
            var that = this;
            if (tiskPodacihoRazitka) {
                this.actions.add(GAction.createPrintAction({
                    name: "actTiskPodacihoRazitka",
                    caption: "Tisk podaciho razitka", //RC 31950215 : Tisk průvodky
                    tooltip: "Tisk podacího razítka", //RC 31950215 : Tisk průvodky
                    tema: "ssl_ptm_doktisk",
                    visible: false,
                    reportStarting: function (rep) {
                        rep.params.X0000 = that.PIDDokumentu;
                        //rep.params.X0009 = Gordic.Report.Client.GReportX0009.GetDefault(UserProcess);
                        rep.params.IXP = that.PIDDokumentu
                    },
                    //reportFinished: function (rep) {
                    //    ;
                    //    //promis.resolve();
                    //},
                    dialogClosed: function (rep) {
                        promis.resolve();
                    }
                }));

                this.actions.actTiskPodacihoRazitka.run();

            } else {
                promis.resolve();
            }
            return promis.promise();
        }
        */
        //#endregion

    }

}